/**
 * NOTES:
 *
 * Minifier doesn't like const
 *
 */
angular.module('app')
.service('Exhibition', ['Album', 'Work', function(Album, Work) {
    var EXHIBITIONS = [{
        // Set future for an upcoming exhibition
        //future: true,
        // Set soon for an upcoming exhibition with artist bios
        //soon: true,
        // Set current for an ongoing exhibition
        // Controls:
        //  Tour availablility
        //  Map downloadability
        //  Which artist page is linked to
        current: true,
        // Set this to true to hide the tour links in the splash and current exhibition screens
        notour: false,
        year: 2025,
        name: 'Homeland | Hostland',
        curators: [ "Fabiola Delgado" ],
        videos: [{
            name: 'Curator Interview',
            id: 'fabiola-delgado',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'FabiolaR_Delgado _Curator_V4_PT_FINAL_854x480_BS_MOBILE_UPDATE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'FabiolaR_Delgado _Curator_V4_PT_FINAL_1280_UPDATE.mp4',
                    type: 'video/mp4'
                }]
            }]
        }]
    }, {
        year: 2023,
        name: 'Sites for Centering and Reflection',
        curators: [ "Jarvis DuBois" ],
        videos: [{
            name: 'Curator Interview',
            id: 'jarvis-dubois',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'JARVIS_DUBOIS_INT_FINAL_854x480_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'JARVIS_DUBOIS_INT_FINAL_1280.mp4',
                    type: 'video/mp4'
                }]
            }]
        }, {
            name: 'Curator Exhibition',
            id: 'jarvis-dubois',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'JARVIS_DUBOIS_ART_FINAL_854x480_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'JARVIS_DUBOIS_ART_FINAL_1280.mp4',
                    type: 'video/mp4'
                }]
            }]
        }]
    }, {
        year: 2021,
        name: 'Human/Nature',
        curators: [ "Kayleigh Bryant-Greenwell" ],
        videos: [{
            name: 'Curator Interview',
            id: 'kayleigh-bryant-greenwell',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'KAYLEIGH_INT_FINAL_854x480_PT_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'KAYLEIGH_INT_FINAL_1280x720_PT.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1920,
                height: 1080,
                formats: [{
                    file: 'KAYLEIGH_INT_FINAL_1920x1080_PT.mp4',
                    type: 'video/mp4'
                }]
            }]
        }]
    }, {
        year: 2018,
        name: 'Absence & Presence',
        curators: [ "Helen Frederick", "Peter Winant" ]
    }, {
        year: 2016,
        name: 'Turf and Terrain',
        curators: [ "Danielle O'Steen" ]
    }, {
        year: 2014,
        name: 'Sculpted: Histories Revealed',
        curators: [ "Deirdre Ehlen MacWilliams" ]
    }, {
        year: 2012,
        name: 'Sculpting Outside the Lines',
        curators: [ "Laura Roulet" ]
    }, {
        year: 2010,
        name: '',
        curators: [ "Shirley Koller" ]
    }, {
        year: 2008,
        name: '',
        curators: [ "Shirley Koller" ]
    }];

    _.forEach(EXHIBITIONS, function(e) {
        e.curators = _.map(e.curators, function(c) {
            return {
                id: _.kebabCase(c),
                curator: c
            };
        });
    });

    var query = function(params) {
        return _.chain(EXHIBITIONS)
        .filter(function(e) {
            return ( ! (params && params.year)) ||
                (params && params.year && params.year == e.year);
        })
        .sortBy('year')
        .reverse()
        .value();
    };
    this.query = query;

    var current = function() {
        return _.head(query({ current: true })) || { };
    };
    this.current = current;
}])
.service('Album', [function() {
    var ALBUMS = { };

    var add = function(name, photos) {
        ALBUMS[name] = photos;
    };
    this.add = add;

    var query = function(params) {
        return params && params.name && ALBUMS[params.name] || [ ];
    };

}])
.service('Permanent', [function() {
    var works = [{
        name: 'Gallo Grande',
        artist: 'Craig Schaffer',
        year: 2008,
        location: '912-1/2 25th St. NW',
        credit: 'Photo by Kate Warren',
        photo: {
            collection: 'permanent',
            orientation: 'landscape',
            file: 'GoKateShoot-FoggyBottom-200.jpg'
        }
    }, {
        name: 'Garden',
        artist: 'Elizabeth Graeber',
        year: 2014,
        location: '923 Hughes Mews NW',
        credit: 'Photo by Dakota Fine',
        photo: {
            collection: 'works'
        }
    }, {
        name: 'Tap Root',
        artist: 'Dalya Luttwak',
        year: 2014,
        location: '809 25th St. NW',
        credit: 'Photo by Dakota Fine',
        photo: {
            collection: 'permanent',
            orientation: 'portrait',
            file: 'GoKateShoot-FoggyBottom-22.jpg'
        }
    }, {
        name: 'Watching Post',
        artist: 'Graham Caldwell',
        year: 2014,
        location: '26th and I Sts. NW',
        credit: 'Photo by Kate Warren',
        purchase: 'Purchased by the Foggy Bottom Association',
        photo: {
            collection: 'permanent',
            orientation: 'landscape',
            file: 'GoKateShoot-FoggyBottom-111.jpg'
        }
    }];

    for(var x = 0, z = _.size(works); x < z; x++) {
        var w = works[x];

        // Permanent works photos live in one place
        if(w.photo.collection == 'permanent') {
            w.photo.url = 'images/permanent/' + w.photo.orientation + '/' + w.photo.file;
            continue;
        }

        // Photos from older exhibitions live in another
        if(w.photo.collection == 'works') {
            w.photo.url = 'images/exhibition/' + w.year + '/works/' + w.name + '-' + w.year + '.jpg';
            continue;
        }
    }

    var workLen = _.size(works);
    var workIdx = 0;

    this.init = function() {
        workIdx = _.random(workLen - 1);
    };

    this.next = function() {
        workIdx = workIdx == workLen - 1 ? 0 : workIdx + 1;
        return works[workIdx];
    };

    this.query = function() {
        return _.cloneDeep(works);
    };
}])
.service('Banner', ['BUILD', 'Work', function(BUILD, Work) {
    var banners = [ ];
    _.forEach(Work.query(), function(w) {
        if(w.banner) {
            banners.push({
                year: w.year,
                artist: w.artist,
                name: w.name,
                align: w.banner.align,
                position: w.banner.position,
                url: BUILD.url + 'images/exhibition/' + w.year + '/works/' + w.image
            });
            return;
        }

        for(var x = 0, z = _.size(w.photos); x < z; x++) {
            var p = w.photos[x];
            if( ! p.banner) {
                continue;
            }

            banners.push({
                year: w.year,
                artist: w.artist,
                name: w.name,
                align: p.banner.align,
                position: p.banner.position,
                url: BUILD.url + 'images/exhibition/' + w.year + '/works/' + w.order + '/' + (x + 1)  + '/' + p.banner.variant + '.jpg'
            });
        }
    });

    this.random = function() {
        return banners[_.random(0, _.size(banners) - 1)];
    };
}])
.service('Banner', ['BUILD', 'Work', function(BUILD, Work) {
    var banners = [ ];
    _.forEach(Work.query(), function(w) {
        if(w.banner) {
            banners.push({
                year: w.year,
                artist: w.artist,
                name: w.name,
                align: w.banner.align,
                position: w.banner.position,
                url: BUILD.url + 'images/exhibition/' + w.year + '/works/' + w.image
            });
            return;
        }

        for(var x = 0, z = _.size(w.photos); x < z; x++) {
            var p = w.photos[x];
            if( ! p.banner) {
                continue;
            }

            banners.push({
                year: w.year,
                artist: w.artist,
                name: w.name,
                align: p.banner.align,
                position: p.banner.position,
                url: BUILD.url + 'images/exhibition/' + w.year + '/works/' + w.order + '/' + (x + 1)  + '/' + p.banner.variant + '.jpg'
            });
        }
    });

    this.random = function() {
        return banners[_.random(0, _.size(banners) - 1)];
    };
}])
.service('Work', [function() {
    // There are currently 15 QR codes with redirects defined in ~/aws/aifb.js
    var WORKS = [{
        year: 2008,
        artist: 'Alan Binstock',
        id: 'alan-binstock',
        name: 'The Mediator - Reborn',
        image: 'The-Mediator-Reborn-2008.jpg',
        website: 'http://alanbinstock.com'
    }, {
        year: 2008,
        artist: 'Pamela Burris',
        id: 'pamela-burris',
        name: 'Accumulative Effect',
        image: 'Accumlative-Effect-2008.jpg'
    }, {
        year: 2008,
        artist: 'Robert T. Cole',
        id: 'robert-t-cole',
        name: 'Leaf',
        image: 'Leaf-2008.jpg',
        website: 'http://www.studiocole.com'
    }, {
        year: 2008,
        artist: 'Alonzo J. Davis',
        id: 'alonzo-j-davis',
        name: 'Turquoise Trail',
        image: 'Turquoise-Trail-2008.jpg',
        website: 'http://alonzodavis.com'
    }, {
        year: 2008,
        artist: 'Nancy Frankel',
        id: 'nancy-frankel',
        name: 'Cosmic Bearings',
        image: 'Cosmic-Bearings-2008.jpg',
        website: 'http://www.nancyfrankel.com'
    }, {
        year: 2008,
        artist: 'Craig Kraft',
        id: 'craig-kraft',
        name: 'Aerial Delineation',
        image: 'Aerial-Delineation-2008.jpg',
        website: 'https://www.craigkraftstudio.com'
    }, {
        year: 2008,
        artist: 'Philippe Mougne',
        id: 'philippe-mougne',
        name: 'Dance',
        image: 'Dance-2008.jpg',
        website: 'http://www.philippemougne.com'
    }, {
        year: 2008,
        artist: 'Sam Noto',
        id: 'sam-noto',
        name: 'Blue',
        image: 'Blue-2008.jpg',
        website: 'http://www.samnoto.com'
    }, {
        year: 2008,
        artist: 'Ethan Rochmis',
        id: 'ethan-rochmis',
        name: 'Tearing Mt. Fuji',
        image: 'Tearing-Mt-Fuji-2008.jpg',
        website: 'http://www.ethanrochmis.com'
    }, {
        year: 2008,
        artist: 'Craig Schaffer',
        id: 'craig-schaffer',
        name: 'Gallino',
        image: 'Gallino-2008.jpg',
        website: 'http://www.craigschaffer.com'
    }, {
        year: 2008,
        artist: 'Mike Shaffer',
        id: 'mike-shaffer',
        name: 'House of Broken Dreams',
        image: 'House-of-Broken-Dreams-2008.jpg',
        website: 'http://mikeshaffer.net'
    }, {
        year: 2008,
        artist: 'Garrett Strang',
        name: 'Incision',
        image: 'Incision-2008.jpg',
        website: 'http://garrettstrangsculpture.com'
    }, {
        year: 2010,
        artist: 'Richard Binder',
        id: 'richard-binder',
        name: 'Cosmos',
        image: 'Cosmos-2010.jpg',
        website: 'http://binderdoc.com'
    }, {
        year: 2010,
        artist: 'Alan Binstock',
        name: 'Quantum L P',
        website: 'http://alanbinstock.com'
    }, {
        year: 2010,
        artist: 'Mike Brining',
        name: 'So Blue',
        website: 'http://briningart.com'
    }, {
        year: 2010,
        artist: 'Jeff Chyatte',
        name: 'Genesis',
        website: 'http://chyattestudios.com'
    }, {
        year: 2010,
        artist: 'Chas Colburn',
        name: 'Tet-Cap #16'
    }, {
        year: 2010,
        artist: 'Pattie Porter Firestone',
        name: 'Flowering Energy',
        website: 'http://www.pattieporterfirestone.com'
    }, {
        year: 2010,
        artist: 'Nancy Frankel',
        name: 'Conversation 1',
        website: 'http://www.nancyfrankel.com'
    }, {
        year: 2010,
        artist: 'Seth Goldstein and Paula Stone',
        name: 'Vine-esque',
        sort: 'Goldstein'
    }, {
        year: 2010,
        artist: 'Don Herman',
        name: 'Flowers'
    }, {
        year: 2010,
        artist: 'Mariah Josephy',
        name: 'Lily Pond'
    }, {
        year: 2010,
        artist: 'Craig Kraft',
        name: 'Lightswept'
    }, {
        year: 2010,
        artist: 'Philippe Mougne',
        name: 'Helios'
    }, {
        year: 2010,
        artist: 'Sam Noto',
        name: 'What is Her Name, Again?',
        website: 'http://www.samnoto.com'
    }, {
        year: 2010,
        artist: 'Mike Shaffer',
        name: 'Lighthouse/Whitehouse'
    }, {
        year: 2010,
        artist: 'Garrett Strang',
        name: 'Incision',
        website: 'http://garrettstrangsculpture.com'
    }, {
        year: 2012,
        artist: 'Joseph Dumbacher and John Dumbacher',
        name: '#286',
        website: 'http://www.dumbacherstudio.com'
    }, {
        year: 2012,
        artist: 'Linda Hesh',
        name: 'Trust and Doubt',
        website: 'http://lindahesh.com'
    }, {
        year: 2012,
        artist: 'Peter Lee and Blake Turner',
        name: 'Craigslist Unrequited',
        sort: 'Lee'
    }, {
        year: 2012,
        artist: 'Barbara Liotta',
        name: 'Dark Sun',
        website: 'http://www.barbaraliotta.com'
    }, {
        year: 2012,
        artist: 'Dalya Luttwak',
        name: 'Alfalfa Root at 4.5 Months Old',
        website: 'http://www.dalyaluttwak.com'
    }, {
        year: 2012,
        artist: 'Patrick McDonough',
        name: '#CR4010 Photo Mural',
        website: 'http://www.pkmcdonough.com'
    }, {
        year: 2012,
        artist: 'Pat McGowan',
        name: 'Cone Tower #3'
    }, {
        year: 2012,
        artist: 'Yukiko Nakashima',
        name: 'Play Residue',
        website: 'https://www.yukikonakashima.com'
    }, {
        year: 2012,
        artist: 'Adam Nelson',
        name: 'Atmospheres'
    }, {
        year: 2012,
        artist: 'Jefferson Pinder',
        name: 'CarWash',
        website: 'http://www.jeffersonpinder.com'
    }, {
        year: 2012,
        artist: 'Foon Sham',
        name: 'Curve',
        website: 'http://www.foonsham.com'
    }, {
        year: 2012,
        artist: 'Dan Steinhilber',
        name: 'Cast Angel'
    }, {
        year: 2012,
        artist: 'Lina Vargas de la Hoz',
        name: 'Growing Culture',
        sort: 'Vargas',
        website: 'http://vargasdelahoz.com'
    }, {
        year: 2014,
        artist: 'Christian Benefiel',
        name: 'Home is Where the Hole Is',
        credit: 'Photo by Dakota Fine',
        website: 'http://christianbenefiel.com',
        banner: {
            position: '100% 45%'
        }
    }, {
        year: 2014,
        artist: 'Greg Braun',
        name: 'Transition',
        credit: 'Photo by Dakota Fine',
        website: 'http://grbraun.com',
        banner: {
            position: '100% 35%'
        }
    }, {
        year: 2014,
        artist: 'Greg Braun',
        name: 'Mascara',
        credit: 'Photo by Dakota Fine',
        banner: {
            position: '100% 35%'
        }
    }, {
        year: 2014,
        artist: 'Graham Caldwell',
        name: 'Watching Post',
        credit: 'Photo by Dakota Fine',
        website: 'http://www.grahamcaldwell.com',
        banner: {
            position: '100% 50%'
        }
    }, {
        year: 2014,
        id: 'joe-fish',
        artist: 'Joseph Fischhaber (Joe Fish)',
        name: 'Total Angel Moroni 2',
        credit: 'Photo by Dakota Fine',
        website: 'http://www.joefish.org',
        banner: {
            position: '100% 10%'
        }
    }, {
        year: 2014,
        id: 'mary-annella-frank',
        artist: 'Mary Annella Frank',
        name: 'Remembering Andromeda',
        credit: 'Photo by Dakota Fine',
        website: 'http://maryannellafrank.com',
        banner: {
            position: '100% 75%'
        }
    }, {
        year: 2014,
        artist: 'Elizabeth Graeber',
        name: 'Garden',
        credit: 'Photo by Dakota Fine',
        website: 'http://elizabethgraeber.com',
        banner: {
            position: '100% 65%'
        }
    }, {
        year: 2014,
        artist: 'Mariah Anne Johnson',
        name: 'Stone',
        credit: 'Photo by Dakota Fine',
        website: 'http://www.mariahannejohnson.com',
        banner: {
            align: 'right',
            position: '100% 42%'
        }
    }, {
        year: 2014,
        artist: 'Laurel Lukaszewski',
        name: 'Ghost 2014',
        credit: 'Photo by Dakota Fine',
        website: 'http://laurellukaszewski.com',
        banner: {
            position: '100% 50%'
        }
    }, {
        year: 2014,
        artist: 'Dalya Luttwak',
        name: 'Five Tap Roots',
        credit: 'Photo by Dakota Fine',
        website: 'http://www.dalyaluttwak.com',
        banner: {
            position: '100% 45%'
        }
    }, {
        year: 2014,
        artist: 'Leigh Maddox',
        name: 'Beebox',
        website: 'http://www.leighmaddox.com',
        banner: {
            position: '100% 20%'
        }
    }, {
        year: 2014,
        artist: 'Rachel Schmidt',
        name: 'Building Aground',
        credit: 'Photo by Dakota Fine',
        website: 'http://www.rachel-schmidt.com',
        banner: {
            position: '100% 85%'
        }
    }, {
        year: 2014,
        artist: 'Paul Steinkoenig',
        name: 'In Harmony',
        credit: 'Photo by Dakota Fine',
        website: 'http://paulsteinkoenig.com',
        banner: {
            position: '100% 25%'
        }
    }, {
        year: 2014,
        artist: 'Veronica Szalus',
        name: 'Chexok: Terraced',
        credit: 'Photo by Dakota Fine',
        website: 'http://www.veronicaszalus.com',
        banner: {
            align: 'right',
            position: '100% 47%'
        }
    }, {
        year: 2014,
        artist: 'Richard Vosseller',
        name: 'Monument',
        credit: 'Photo by Dakota Fine',
        website: 'http://www.rvosseller.com',
        banner: {
            position: '100% 47%'
        }
    }, {
        year: 2014,
        artist: 'Bill Wood',
        name: 'Square Wave',
        credit: 'Photo by Dakota Fine',
        website: 'http://www.billwoodsculptor.com',
        banner: {
            position: '100% 60%'
        }
    }, {
        year: 2016,
        artist: 'Dane Winkler',
        name: 'Round Top Dig',
        order: 1,
        credit: 'Photo by Kate Warren',
        website: 'http://www.danewinkler.net',
        photos: [{
            banner: {
                variant: 'full',
                position: '100% 70%'
            }
        }]
    }, {
        year: 2016,
        artist: 'Jonathan Monaghan',
        name: 'Agnus Dei (After Zurbarán)',
        order: 2,
        credit: 'Photo by Kate Warren',
        website: 'http://www.jonmonaghan.com',
        photos: [{
            banner: {
                variant: 'full',
                position: '100% 65%'
            }
        }]
    }, {
        year: 2016,
        artist: 'Lisa Dillin',
        name: 'Equivalent Formations V',
        order: 3,
        credit: 'Photo by Kate Warren',
        website: 'http://www.lisadillin.com',
        photos: [{
            // Placeholder
        }, {
            banner: {
                align: 'right',
                variant: 'full',
                position: '100% 50%'
            }
        }]
    }, {
        year: 2016,
        artist: 'Becky Borlan',
        name: 'Bricks',
        order: 4,
        credit: 'Photo by Kate Warren',
        website: 'http://www.beckyborlan.com',
        photos: [{
            banner: {
                align: 'right',
                variant: 'full',
                position: '100% 37%'
            }
        }]
    }, {
        year: 2016,
        artist: 'Brian Davis',
        name: 'Anywhere',
        order: 5,
        credit: 'Photo by Kate Warren',
        website: 'http://inadvisabledrain.com',
        photos: [{
            banner: {
                align: 'right',
                variant: 'full',
                position: '100% 37%'
            }
        }]
    }, {
        year: 2016,
        artist: 'Rob Hackett',
        name: 'Step Right Up',
        order: 6,
        credit: 'Photo by Kate Warren',
        website: 'http://www.robhackett.net',
        photos: [{
            banner: {
                variant: 'full',
                position: '100% 45%'
            }
        }]
    }, {
        year: 2016,
        artist: 'Krista Caballero and Frank Ekeberg',
        name: 'Birding the Future',
        order: 7,
        credit: 'Photo by Kate Warren',
        photos: [{
            banner: {
                variant: 'full',
                position: '100% 35%'
            }
        }]
    }, {
        year: 2016,
        artist: 'Nicole Herbert',
        name: 'Building Blocks',
        order: 8,
        credit: 'Photo by Kate Warren',
        website: 'http://nherbert.com',
        photos: [{
            banner: {
                align: 'right',
                variant: 'full',
                position: '100% 95%'
            }
        }]
    }, {
        year: 2016,
        artist: 'Julie Zirlin',
        name: 'Wave',
        order: 9,
        credit: 'Photo by Kate Warren',
        website: 'http://www.juliezirlin.com',
        photos: [{
            // Placeholder
        }, {
            banner: {
                variant: 'full',
                position: '100% 50%'
            }
        }]
    }, {
        year: 2016,
        artist: 'Benjamin Andrew',
        name: 'Foggy Bottom Microobservatory',
        order: 10,
        credit: 'Photo by Kate Warren',
        website: 'http://benjaminandrew.net'
    }, {
        year: 2016,
        artist: 'Lindsay Pichaske',
        name: 'Kingdom',
        order: 11,
        credit: 'Photo by Kate Warren',
        website: 'http://www.lindsaypichaske.com',
        photos: [{
            banner: {
                variant: 'full',
                position: '100% 60%'
            }
        }]
    }, {
        year: 2016,
        artist: 'Patrick McDonough',
        name: 'Adaptation Terrarium: Moringa',
        order: 12,
        website: 'http://www.pkmcdonough.com'
    }, {
        year: 2016,
        artist: 'Eames Armstrong',
        name: 'Fog',
        order: 13,
        credit: 'Photo by Laylaa Randera',
        website: 'http://www.eamesarmstrong.com',
        photos: [{
            credit: 'Photo by Kate Warren',
            banner: {
                variant: 'full',
                position: '100% 70%'
            }
        }]
    }, {
        year: 2018,
        artist: 'John Ruppert',
        name: 'Pumpkins',
        description: "Ruppert responds to the beauty of the land and ways humans change its appearance.",
        location: '842 New Hampshire Ave. NW',
        website: 'http://www.johnruppert.com',
        order: 1,
        credit: 'Photo by Greg Staley',
        photos: [{
            press: true,
            landscape: 'full'
        }, {
            press: true,
            landscape: 'full',
            banner: {
                variant: 'full',
                position: '100% 75%'
            }
        }, {
            portrait: 'full'
        }],
        photo: {
            square: '1/square.jpg'
        }
    }, {
        year: 2018,
        artist: 'Jeremy Thomas Kunkel',
        name: 'Arm, incase',
        description: "Kunkel considers ancient and continuing questions about the consequences of human interaction with the contemporary landscape.",
        location: '2538 Queen Annes Lane NW',
        website: 'http://www.asubtle.com',
        order: 13,
        credit: 'Photo by Greg Staley',
        photos: [{
            press: true,
            landscape: 'full'
        }, {
            portrait: 'full',
            banner: {
                variant: 'full',
                position: '100% 60%'
            }
        }],
        photo: {
            square: '1/full.jpg'
        }
    }, {
        year: 2018,
        artist: 'Melissa Hill',
        name: 'The Closest Point of Approach',
        description: "Hill's methodology mirrors scientific inquiry of examination, focusing on essential questions that invite us to consider not only who we are, but why we exist.",
        location: '2419 I St. NW',
        note: 'Removed due to weather-induced damage.',
        website: 'http://www.melissahillart.com',
        order: 8,
        credit: 'Photo by Greg Staley',
        photos: [{
            press: true,
            portrait: 'full',
            banner: {
                variant: 'full',
                position: '100% 36%'
            }
        }, {
            portrait: 'full'
        }],
        photo: {
            square: '1/full.jpg'
        }
    }, {
        year: 2018,
        artist: 'Adam Bradley',
        name: 'Struggle',
        description: "Bradley explores triumph and failure, fear and attraction, and the urges to rescue or flee.",
        location: '2426 I St. NW',
        website: 'http://www.adambradleyart.com',
        order: 7,
        credit: 'Photo by Greg Staley',
        photos: [{
            press: true,
            landscape: 'full',
            banner: {
                variant: 'full',
                position: '100% 20%'
            }
        }, {
            portrait: 'full',
            banner: {
                align: 'right',
                variant: 'full',
                position: '100% 15%'
            }
        }, {
            landscape: 'full'
        }, {
            landscape: 'full'
        }],
        photo: {
            square: '1/full.jpg'
        }
    }, {
        year: 2018,
        artist: 'Nehemiah Dixon',
        name: 'Hoodies',
        description: "Dixon's empty hoodies ask us to consider what is within them and what is not. He confronts origins of discrimination and wants us to consider what may happen when we believe we see something that isn't there.",
        location: '810 New Hampshire Ave. NW',
        order: 3,
        credit: 'Photo by Greg Staley',
        photos: [{
            press: true,
            landscape: 'full',
            banner: {
                variant: 'full',
                position: '100% 28%'
            }
        }, {
            landscape: 'full'
        }],
        photo: {
            square: '1/square.jpg'
        }
    }, {
        year: 2018,
        artist: 'Linda DePalma',
        name: 'Gingko at Peace',
        description: "DePalma draws upon intricate botanical and biological systems to create elegantly formed shapes that play with the balance of light and shadow",
        location: '826 25th St. NW',
        website: 'https://bakerartist.org/portfolios/linda-depalma',
        order: 4,
        credit: 'Photo by Greg Staley',
        photos: [{
            press: true,
            portrait: 'full',
            banner: {
                variant: 'full',
                position: '100% 27.5%'
            }
        }, {
            portrait: 'full'
        }, {
            portrait: 'full'
        }, {
            portrait: 'full'
        }],
        photo: {
            square: '1/full.jpg'
        }
    }, {
        year: 2018,
        artist: 'Richard Lew',
        name: 'Event Horizon',
        description: "Lew explores visible, invisible and transformative qualities of natural and manmade materials to create a sum greater than their parts.",
        location: '2518 I St. NW',
        website: 'http://richardlewsculptor.blogspot.com',
        order: 9,
        credit: 'Photo by Greg Staley',
        photos: [{
            press: true,
            portrait: 'full'
        }, {
            portrait: 'full'
        }],
        photo: {
            square: '1/full.jpg'
        }
    }, {
        year: 2018,
        artist: 'Nancy Sausser',
        name: 'A Circle on the Land',
        description: "In Sausser's work, we find relationships of positive and negative or presence and illusion.",
        location: '925 26th St. NW',
        order: 14,
        credit: 'Photo by Greg Staley',
        photos: [{
            press: true,
            landscape: 'full',
            banner: {
                variant: 'full',
                position: '100% 49%'
            }
        }, {
            press: true,
            landscape: 'full'
        }, {
            portrait: 'full'
        }],
        photo: {
            square: '1/full.jpg'
        }
    }, {
        year: 2018,
        artist: 'David Brooks',
        name: 'Continuous Service Altered Daily',
        description: "Brooks looks at agricultural machinery and the intentional cause and effect of cogs and wheels as a reflection of nature’s imperative.",
        location: '909 Hughes Mews',
        website: 'http://davidbrooksstudio.com',
        order: 15,
        credit: 'Photo by Greg Staley',
        photos: [{
            press: true,
            portrait: 'full'
        }, {
            press: true,
            landscape: 'full'
        }, {
            landscape: 'full',
            banner: {
                variant: 'full',
                position: '100% 68%'
            }
        }],
        photo: {
            square: '1/square.jpg'
        }
    }, {
        year: 2018,
        artist: 'Lisa Scheer',
        name: 'Lady Slipper',
        description: "Scheer builds elegant, abstract forms that suggest origins from nature that narrate stories we all share.",
        location: '2520 I St. NW',
        website: 'http://www.mckayscheer.com',
        order: 10,
        credit: 'Photo by Greg Staley',
        photos: [{
            press: true,
            portrait: 'full'
        }, {
            portrait: 'full'
        }, {
            portrait: 'full'
        }],
        photo: {
            square: '1/full.jpg'
        }
    }, {
        year: 2018,
        artist: 'Sean Hennessey',
        name: 'Ways We Grow',
        description: "Hennessey's playful narratives utilize light and video to relate stories of hopes, dreams, memories and transformations based on myth, religion, science, and personal experience.",
        location: '835 25th St. NW',
        website: 'http://seanhennesseyart.wixsite.com/sean-hennessey',
        order: 5,
        credit: 'Photo by Greg Staley',
        photos: [{
            press: true,
            portrait: 'full',
            banner: {
                variant: 'full',
                position: '100% 60%'
            }
        }, {
            press: true,
            portrait: 'full'
        }, {
            portrait: 'full'
        }],
        photo: {
            square: '1/full.jpg'
        }
    }, {
        year: 2018,
        artist: 'Erwin Timmers',
        name: 'Glimpse of Possibilities',
        description: "Timmers' innovative glassworks invite us to explore the relationship between surface and core to reflect upon our own and society’s structures.",
        location: '835 25th St. NW',
        website: 'http://erwintimmers.com',
        order: 6,
        credit: 'Photo by Greg Staley',
        photos: [{
            press: true,
            portrait: 'full',
            banner: {
                variant: 'full',
                position: '100% 52%'
            }
        }],
        photo: {
            square: '1/full.jpg'
        }
    }, {
        year: 2018,
        artist: 'Emily Fussner',
        name: 'What Delineates',
        description: "Fussner's site responsive work transforms absence into presence through exploration of liminal space.",
        location: '915 26th St. NW',
        website: 'http://www.emilyfussner.com',
        order: 12,
        credit: 'Photo by Greg Staley',
        photos: [{
            press: true,
            portrait: 'full'
        }, {
            portrait: 'full',
            banner: {
                variant: 'full',
                position: '100% 50%'
            }
        }, {
            portrait: 'full'
        }],
        photo: {
            square: '1/square.jpg'
        }
    }, {
        year: 2018,
        artist: 'Brian Dailey',
        name: 'Thinking the Unthinkable',
        description: "Dailey's art reflects his life experiences in arms control, space policy, intelligence systems, and international security.",
        location: '2527 I St. NW',
        website: 'http://www.briandaileyart.com',
        order: 11,
        credit: 'Photo by Greg Staley',
        photos: [{
            press: true,
            portrait: 'full'
        }, {
            portrait: 'full'
        }, {
            portrait: 'full',
            banner: {
                variant: 'full',
                position: '100% 12%'
            }
        }],
        photo: {
            square: '1/full.jpg'
        }
    }, {
        year: 2018,
        artist: 'Valerie Theberge',
        name: 'Multiplicity',
        description: "Theberge invites us to connect to a part of ourselves where multiple simultaneous experiences coexist; where life is steady and synchronous but uncertain.",
        location: '842 New Hampshire Ave. NW',
        website: 'http://www.valerietheberge.com',
        order: 2,
        credit: 'Photo by Greg Staley',
        photos: [{
            press: true,
            portrait: 'full'
        }, {
            portrait: 'full',
            banner: {
                variant: 'full',
                position: '100% 65%'
            }
        }],
        photo: {
            square: '1/square.jpg'
        }
    }, {
        nophoto: true,
        year: 2021,
        artist: 'Robin Bell',
        order: 1,
        name: 'Readymade Rainbow',
        description: '"Readymade Rainbow" is a field of color-shifting rainbow color. Bell\'s self-sustaining, solar-powered installation aims to create a sense of peace in the street. A respite that creates a connection between the humans and nature in the city.',
        location: '842 New Hampshire Ave. NW',
        website: 'http://bellvisuals.com',
        photos: [{
            press: true,
            landscape: 'full',
            banner: {
                align: 'right',
                variant: 'full',
                position: '100% 75%'
            }
        }, {
            landscape: 'full',
            banner: {
                variant: 'full',
                position: '100% 5%'
            }
        }, {
            landscape: 'full',
            banner: {
                variant: 'full',
                position: '100% 5%'
            }
        }, {
            landscape: 'full'
        }, {
            portrait: 'full'
        }],
        // Defines the tour photo
        credit: 'Photo by Nancy Daly',
        photo: {
            square: '1/square.jpg'
        },
        videos: [{
            name: 'Work',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'ROBIN_ART_PIECE_FINAL_854x480_PT_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'ROBIN_ART_PIECE_FINAL_1280x720_PT.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1920,
                height: 1080,
                formats: [{
                    file: 'ROBIN_ART_PIECE_FINAL_1920x1080_PT.mp4',
                    type: 'video/mp4'
                }]
            }]
        }, {
            name: 'Interview',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'ROBIN_INT_FINAL_854x480_PT_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'ROBIN_INT_FINAL_1280x720_PT.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1920,
                height: 1080,
                formats: [{
                    file: 'ROBIN_INT_FINAL_1920x1080_PT.mp4',
                    type: 'video/mp4'
                }]
            }]
        }]
    }, {
        year: 2021,
        artist: 'Dalya Luttwak',
        order: 2,
        name: 'Still Life',
        description: 'Fronds of palm trees were the inspiration for "Still Life." Luttwak chose an unexpected color to draw attention to the organic shapes of this plant and capture a moment in its existence',
        location: '810 New Hampshire Ave. NW',
        website: 'http://www.dalyaluttwak.com',
        photos: [{
            press: true,
            portrait: 'full'
        }, {
            landscape: 'full',
            banner: {
                align: 'right',
                variant: 'full',
                position: '100% 20%'
            }
        }, {
            portrait: 'full'
        }, {
            landscape: 'full',
            banner: {
                variant: 'full',
                position: '100% 0%'
            }
        }],
        // Defines the tour photo
        credit: 'Photo by Nancy Daly',
        photo: {
            square: '1/square.jpg'
        },
        videos: [{
            name: 'Work',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'DALYA_ART_PIECE_FINAL_854x480_PT_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'DALYA_ART_PIECE_FINAL_1280x720_PT.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1920,
                height: 1080,
                formats: [{
                    file: 'DALYA_ART_PIECE_FINAL_1920x1080_PT.mp4',
                    type: 'video/mp4'
                }]
            }]
        }, {
            name: 'Interview',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'DALYA_INT_FINAL_854x480_PT_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'DALYA_INT_FINAL_1280x720_PT.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1920,
                height: 1080,
                formats: [{
                    file: 'DALYA_INT_FINAL_1920x1080_PT.mp4',
                    type: 'video/mp4'
                }]
            }]
        }]
    }, {
        year: 2021,
        artist: 'Lisa Fedon',
        order: 3,
        name: 'Safe Haven',
        description: '"Safe Haven" represents aspects of Fedon\'s childhood creating "safe spaces" in the woods. A yellow car piece suggests sunlight coming through the trees, a spiral - the night sky, ladders - growth and experiences, narrow strips - grasses, a key - holding the power to unlock a child’s imagination.',
        location: '826 25th St. NW',
        website: 'http://www.lisafedon.com',
        photos: [{
            press: true,
            portrait: 'full'
        }, {
            portrait: 'full'
        }, {
            portrait: 'full'
        }, {
            landscape: 'full',
            banner: {
                variant: 'full',
                position: '100% 10%'
            }
        }],
        // Defines the tour photo
        credit: 'Photo by Nancy Daly',
        photo: {
            square: '1/square.jpg'
        },
        videos: [{
            name: 'Work',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'LISA_ART_PIECE_FINAL_854x480_PT_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'LISA_ART_PIECE_FINAL_1280x720_PT.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1920,
                height: 1080,
                formats: [{
                    file: 'LISA_ART_PIECE_FINAL_1920x1080_PT.mp4',
                    type: 'video/mp4'
                }]
            }]
        }, {
            name: 'Interview',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'LISA_INT_FINAL_854x480_PT_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'LISA_INT_FINAL_1280x720_PT.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1920,
                height: 1080,
                formats: [{
                    file: 'LISA_INT_FINAL_1920x1080_PT.mp4',
                    type: 'video/mp4'
                }]
            }]
        }]
    }, {
        year: 2021,
        artist: 'Sanzi Kermes',
        order: 4,
        name: 'Tumbleweed',
        description: '"Tumbleweed" is a reflection on the transience of nature: its changing moods and life cycles amongst weather conditions and how our interaction, or exchange, is fleeting at best.',
        location: '835 25th St. NW',
        website: 'http://www.sanzistudio.com',
        photos: [{
            press: true,
            landscape: 'full'
        }, {
            landscape: 'full',
            banner: {
                variant: 'full',
                position: '100% 0%'
            }
        }, {
            landscape: 'full',
        }, {
            landscape: 'full',
        }],
        // Defines the tour photo
        credit: 'Photo by Nancy Daly',
        photo: {
            square: '1/square.jpg'
        },
        videos: [{
            name: 'Work',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'SANZI_ART_PIECE_FINAL_854x480_PT_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'SANZI_ART_PIECE_FINAL_1280x720_PT.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1920,
                height: 1080,
                formats: [{
                    file: 'SANZI_ART_PIECE_FINAL_1920x1080_PT.mp4',
                    type: 'video/mp4'
                }]
            }]
        }, {
            name: 'Interview',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'SANZI_INT_FINAL_854x480_PT_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'SANZI_INT_FINAL_1280x720_PT.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1920,
                height: 1080,
                formats: [{
                    file: 'SANZI_INT_FINAL_1920x1080_PT.mp4',
                    type: 'video/mp4'
                }]
            }]
        }]
    }, {
        year: 2021,
        artist: 'Jerry Truong',
        order: 5,
        name: 'Where is Your Allegiance? (Can Language Express a Doubt So Deep?)',
        description: 'Truong\'s installation emerged out of reflections on the natural catastrophes we are facing at the start of this new decade: a global pandemic, the profound effects of climate change, and social/political instability caused by the dwindling of natural resources. Five signs displaying words from the American Pledge of Allegiance each ending with a question mark beg the question, despite its regular recitation, how genuine have we as Americans adhered to these principles?',
        location: '835 25th St. NW',
        website: 'http://www.jerrytruong.com',
        photos: [{
            press: true,
            landscape: 'full'
        }, {
            landscape: 'full'
        }, {
            landscape: 'full'
        }, {
            portrait: 'full',
            banner: {
                align: 'right',
                variant: 'full',
                position: '100% 30%'
            }
        }, {
            portrait: 'full'
        }],
        // Defines the tour photo
        credit: 'Photo by Nancy Daly',
        photo: {
            square: '1/square.jpg'
        },
        videos: [{
            name: 'Work',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'JERRY_ART_PIECE_FINAL_854x480_PT_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'JERRY_ART_PIECE_FINAL_1280x720_PT.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1920,
                height: 1080,
                formats: [{
                    file: 'JERRY_ART_PIECE_FINAL_1920x1080_PT.mp4',
                    type: 'video/mp4'
                }]
            }]
        }, {
            name: 'Interview',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'JERRY_INT_FINAL_854x480_PT_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'JERRY_INT_FINAL_1280x720_PT.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1920,
                height: 1080,
                formats: [{
                    file: 'JERRY_INT_FINAL_1920x1080_PT.mp4',
                    type: 'video/mp4'
                }]
            }]
        }]
    }, {
        year: 2021,
        artist: 'Jeff Chyatte',
        order: 6,
        name: 'The Woman',
        description: 'Strong, capable and loving, Chyatte\'s "The Woman" imbues the warmth and companionship of a woman of girth in patinaed aluminum.',
        location: '2419 I St. NW',
        website: 'http://chyattestudios.com',
        photos: [{
            press: true,
            landscape: 'full'
        }, {
            portrait: 'full'
        }, {
            landscape: 'full',
            banner: {
                variant: 'full',
                position: '100% 40%'
            }
        }, {
            landscape: 'full',
            banner: {
                align: 'right',
                variant: 'full',
                position: '100% 45%'
            }
        }, {
            portrait: 'full'
        }, {
            portrait: 'full'
        }],
        // Defines the tour photo
        credit: 'Photo by Nancy Daly',
        photo: {
            square: '1/square.jpg'
        },
        videos: [{
            name: 'Work',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'JEFF_ART_PIECE_2_FINAL_854x480_PT_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'JEFF_ART_PIECE_2_FINAL_1280x720_PT.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1920,
                height: 1080,
                formats: [{
                    file: 'JEFF_ART_PIECE_2_FINAL_1920x1080_PT.mp4',
                    type: 'video/mp4'
                }]
            }]
        }, {
            name: 'Interview',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'JEFF_INT_FINAL_854x480_PT_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'JEFF_INT_FINAL_1280x720_PT.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1920,
                height: 1080,
                formats: [{
                    file: 'JEFF_INT_FINAL_1920x1080_PT.mp4',
                    type: 'video/mp4'
                }]
            }]
        }]
    }, {
        year: 2021,
        artist: 'Stephanie Garon',
        order: 7,
        name: 'Lament',
        description: 'Women around the world, from Bangladesh to Benin, carry bundles of sticks to support their community. Confined by land and ritualistic roles, “Lament” references claim, women\'s labor, and impermanence.',
        location: '2518 I St. NW',
        website: 'https://www.garonstudio.com',
        photos: [{
            press: true,
            portrait: 'full'
        }, {
            landscape: 'full'
        }, {
            landscape: 'full',
            banner: {
                variant: 'full',
                position: '100% 40%'
            }
        }, {
            landscape: 'full'
        }],
        // Defines the tour photo
        credit: 'Photo by Nancy Daly',
        photo: {
            square: '1/square.jpg'
        },
        videos: [{
            name: 'Work',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'STEPHANIE_ART_PIECE_FINAL_854x480_PT_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'STEPHANIE_ART_PIECE_FINAL_1280x720_PT.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1920,
                height: 1080,
                formats: [{
                    file: 'STEPHANIE_ART_PIECE_FINAL_1920x1080_PT.mp4',
                    type: 'video/mp4'
                }]
            }]
        }, {
            name: 'Interview',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'STEPHANIE_INT_FINAL_854x480_PT_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'STEPHANIE_INT_FINAL_1280x720_PT.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1920,
                height: 1080,
                formats: [{
                    file: 'STEPHANIE_INT_FINAL_1920x1080_PT.mp4',
                    type: 'video/mp4'
                }]
            }]
        }]
    }, {
        year: 2021,
        artist: 'Stephanie Garon',
        order: 8,
        name: 'Lament',
        description: 'Women around the world, from Bangladesh to Benin, carry bundles of sticks to support their community. Confined by land and ritualistic roles, “Lament” references claim, women\'s labor, and impermanence.',
        location: '2520 I St. NW',
        website: 'https://www.garonstudio.com',
        photos: [{
            landscape: 'full'
        }, {
            landscape: 'full'
        }],
        // Defines the tour photo
        credit: 'Photo by Nancy Daly',
        photo: {
            square: '1/square.jpg'
        },
        videos: [{
            name: 'Work',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'STEPHANIE_ART_PIECE_FINAL_854x480_PT_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'STEPHANIE_ART_PIECE_FINAL_1280x720_PT.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1920,
                height: 1080,
                formats: [{
                    file: 'STEPHANIE_ART_PIECE_FINAL_1920x1080_PT.mp4',
                    type: 'video/mp4'
                }]
            }]
        }, {
            name: 'Interview',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'STEPHANIE_INT_FINAL_854x480_PT_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'STEPHANIE_INT_FINAL_1280x720_PT.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1920,
                height: 1080,
                formats: [{
                    file: 'STEPHANIE_INT_FINAL_1920x1080_PT.mp4',
                    type: 'video/mp4'
                }]
            }]
        }]
    }, {
        year: 2021,
        artist: 'Jeff Chyatte',
        order: 9,
        name: 'Nebulous',
        description: 'Chyatte\'s work attempts to understand the human condition through discovery of the relationships between its basic components. Sculpted in aluminum and granite, "Nebulous" reflects this ever changing human condition.',
        location: '2527 I St. NW',
        website: 'http://chyattestudios.com',
        photos: [{
            press: true,
            portrait: 'full'
        }, {
            landscape: 'full',
            banner: {
                align: 'right',
                variant: 'full',
                position: '100% 65%'
            }
        }, {
            portrait: 'full'
        }],
        // Defines the tour photo
        credit: 'Photo by Nancy Daly',
        photo: {
            square: '1/square.jpg'
        },
        videos: [{
            name: 'Work',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'JEFF_ART_PIECE_1_FINAL_854x480_PT_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'JEFF_ART_PIECE_1_FINAL_1280x720_PT.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1920,
                height: 1080,
                formats: [{
                    file: 'JEFF_ART_PIECE_1_FINAL_1920x1080_PT.mp4',
                    type: 'video/mp4'
                }]
            }]
        }, {
            name: 'Interview',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'JEFF_INT_FINAL_854x480_PT_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'JEFF_INT_FINAL_1280x720_PT.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1920,
                height: 1080,
                formats: [{
                    file: 'JEFF_INT_FINAL_1920x1080_PT.mp4',
                    type: 'video/mp4'
                }]
            }]
        }]
    }, {
        year: 2021,
        artist: 'Jordann Wine',
        order: 10,
        name: 'Triangle Golden Ratio',
        description: 'Wine draws connection between art and nature in "Triangle Golden Ratio," inspired by the golden ratio and its connection to the Fibonacci sequence. Wine uses triangles and subtle color changes in shades of green to explore shape and curve. Found in nature, the golden ratio\'s patterns were even utilized by artists in the renaissance as the basis for proportions in their great works.',
        location: '915 26th St. NW',
        website: 'https://www.jordannwine.com',
        photos: [{
            press: true,
            portrait: 'full'
        }, {
            portrait: 'full',
            banner: {
                variant: 'full',
                position: '100% 57%'
            }
        }, {
            portrait: 'full'
        }],
        // Defines the tour photo
        credit: 'Photo by Nancy Daly',
        photo: {
            square: '1/square.jpg'
        },
        videos: [{
            name: 'Work',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'JORDANN_ART_PIECE_FINAL_854x480_PT_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'JORDANN_ART_PIECE_FINAL_1280x720_PT.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1920,
                height: 1080,
                formats: [{
                    file: 'JORDANN_ART_PIECE_FINAL_1920x1080_PT.mp4',
                    type: 'video/mp4'
                }]
            }]
        }, {
            name: 'Interview',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'JORDANN_INT_FINAL_854x480_PT_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'JORDANN_INT_FINAL_1280x720_PT.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1920,
                height: 1080,
                formats: [{
                    file: 'JORDANN_INT_FINAL_1920x1080_PT.mp4',
                    type: 'video/mp4'
                }]
            }]
        }]
    }, {
        year: 2021,
        artist: 'Jacqui Crocetta',
        order: 11,
        name: 'In The Shelter of Each Other',
        description: 'Crocetta honors and brings attention to the victims of extreme weather events that have become more prevalent due to climate change. Wildfires, heatwaves and floods disproportionately affect vulnerable populations.',
        location: '919 26th St. NW',
        website: 'http://www.jacquicrocetta.com',
        photos: [{
            press: true,
            portrait: 'full'
        }, {
            landscape: 'full',
            banner: {
                align: 'right',
                variant: 'full',
                position: '100% 40%'
            }
        }, {
            landscape: 'full',
            banner: {
                variant: 'full',
                position: '100% 40%'
            }
        }, {
            landscape: 'full'
        }, {
            portrait: 'full'
        }],
        // Defines the tour photo
        credit: 'Photo by Nancy Daly',
        photo: {
            square: '1/square.jpg'
        },
        videos: [{
            name: 'Work',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'JACQUI_ART_PIECE_FINAL_854x480_PT_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'JACQUI_ART_PIECE_FINAL_1280x720_PT.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1920,
                height: 1080,
                formats: [{
                    file: 'JACQUI_ART_PIECE_FINAL_1920x1080_PT.mp4',
                    type: 'video/mp4'
                }]
            }]
        }, {
            name: 'Interview',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'JACQUI_INT_FINAL_854x480_PT_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'JACQUI_INT_FINAL_1280x720_PT.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1920,
                height: 1080,
                formats: [{
                    file: 'JACQUI_INT_FINAL_1920x1080_PT.mp4',
                    type: 'video/mp4'
                }]
            }]
        }]
    }, {
        year: 2021,
        artist: 'Lynda Andrews-Barry',
        order: 12,
        name: 'Pearl Dream',
        description: 'Andrews-Barry\'s installation commemorates The Pearl Incident of 1848, when 77 domestic slaves working in area homes and hotels attempted to escape on a schooner named The Pearl.The captured slaves were re-sold to buyers needing field hands, including one girl of 13 years old working in a residence near the installation site at 25th and Eye Streets, N.W.',
        location: '925 26th St. NW',
        website: 'https://lyndaandrews-barry.com',
        photos: [{
            press: true,
            landscape: 'full'
        }, {
            landscape: 'full'
        }, {
            landscape: 'full',
            banner: {
                align: 'right',
                variant: 'full',
                position: '100% 20%'
            }
        }],
        // Defines the tour photo
        credit: 'Photo by Nancy Daly',
        photo: {
            square: '1/square.jpg'
        },
        videos: [{
            name: 'Work',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'LYNDA_ART_PIECE_FINAL_854x480_PT_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'LYNDA_ART_PIECE_FINAL_1280x720_PT.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1920,
                height: 1080,
                formats: [{
                    file: 'LYNDA_ART_PIECE_FINAL_1920x1080_PT.mp4',
                    type: 'video/mp4'
                }]
            }]
        }, {
            name: 'Interview',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'LYNDA_INT_FINAL_854x480_PT_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'LYNDA_INT_FINAL_1280x720_PT.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1920,
                height: 1080,
                formats: [{
                    file: 'LYNDA_INT_FINAL_1920x1080_PT.mp4',
                    type: 'video/mp4'
                }]
            }]
        }]
    }, {
        year: 2021,
        artist: 'Leigh Maddox and Lucia Paulsen',
        order: 13,
        name: 'Memorial',
        description: 'In "Memorial," the names of endangered and extinct species of the Delmarva are written onto a bench upon which people can sit and contemplate such topics. Layered in a style that evokes graffiti and poster walls, the writing communicates a sense of movement and urgency that the artists hope viewers will bring to the conversation.',
        location: '909 Hughes Mews',
        website: 'http://www.leighmaddox.com',
        photos: [{
            press: true,
            landscape: 'full'
        }, {
            landscape: 'full',
            banner: {
                align: 'right',
                variant: 'full',
                position: '100% 25%'
            }
        }, {
            portrait: 'full'
        }],
        // Defines the tour photo
        credit: 'Photo by Nancy Daly',
        photo: {
            square: '1/square.jpg'
        },
        videos: [{
            name: 'Work',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'LEIGH_ART_PIECE_FINAL_854x480_PT_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'LEIGH_ART_PIECE_FINAL_1280x720_PT.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1920,
                height: 1080,
                formats: [{
                    file: 'LEIGH_ART_PIECE_FINAL_1920x1080_PT.mp4',
                    type: 'video/mp4'
                }]
            }]
        }, {
            name: 'Interview',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'LEIGH_INT_FINAL_854x480_PT_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'LEIGH_INT_FINAL_1280x720_PT.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1920,
                height: 1080,
                formats: [{
                    file: 'LEIGH_INT_FINAL_1920x1080_PT.mp4',
                    type: 'video/mp4'
                }]
            }]
        }]
    }, {
        year: 2023,
        artist: 'Asha Elana Casey',
        order: 3,
        name: 'Ruminations 1-4',
        nophoto: false,
        description: 'This installation finds roots in the Carolinas and in general the American South referencing bottle trees and libation. Each vessel holds water as a reference to reflection, meditation, and an African cultural past. Mosaics, glitter, and stylized greenery cover the vessels along with the wire-attached indigo blue bottles.This color has significant spiritual ties to protection across cultures.',
        location: '826 25th St. NW',
        website: 'http://ashaelanacasey.com',
        photos: [{
            portrait: 'full',
            tour: {
                size: '100%',
                position: '100% 81%',
                padding: '75%'
            }
        }],
        // Defines the tour photo
        credit: 'Photo by Peter Maye',
        photo: {
            square: '1/square.jpg'
        },
        videos: [{
            name: 'Work',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'ASHA_ELANA_CASEY_ART_FINAL_854x480_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'ASHA_ELANA_CASEY_ART_FINAL_1280.mp4',
                    type: 'video/mp4'
                }]
            }]
        }, {
            name: 'Interview',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'ASHA_ELANA_CASEY_INT_FINAL_854x480_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'ASHA_ELANA_CASEY_INT_FINAL_1280.mp4',
                    type: 'video/mp4'
                }]
            }]
        }]
    }, {
        year: 2023,
        artist: 'Mahari Chabwera',
        order: 6,
        name: 'Sun Gate',
        nophoto: false,
        description: 'Sun worship is a recurring theme in my work, symbolizing the cycle of going through the fire. As an ancient and omnipresent tradition, solar veneration offers clear and bold direction for the way forward. As a personal practice, it warms, refuels, and relieves me.',
        location: '2511 I St. NW',
        website: 'https://www.maharichabwera.com',
        photos: [{
            portrait: 'full',
            tour: {
                size: '100%',
                position: '100% 68%',
                padding: '70%'
            }
        }],
        // Defines the tour photo
        credit: 'Photo by Peter Maye',
        photo: {
            square: '1/square.jpg'
        },
        videos: [{
            name: 'Work',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'MAHARI_CHABWERA_ART_FINAL_854x480_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'MAHARI_CHABWERA_ART_FINAL_1280.mp4',
                    type: 'video/mp4'
                }]
            }]
        }, {
            name: 'Interview',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'MAHARI_CHABWERA_INT_FINAL_854x480_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'MAHARI_CHABWERA_INT_FINAL_1280.mp4',
                    type: 'video/mp4'
                }]
            }]
        }]
    }, {
        year: 2023,
        artist: 'Orlando Dominguez',
        order: 11,
        name: 'Trinity of Transcendence',
        nophoto: false,
        description: 'The poetic word is one that alternates between fear and love, mortality and transience, isolation and alienation. I address these relationships in a way that explores the viewers’ understanding of solace with the visual word in a physical structure. Of particular interest to me is the conjunction of spirituality, abstraction, the body, and the collective memory. I want the words to be revealed within these sculptures, speaking to the thoughtful and meditative process of the text as the image.',
        location: '2538 Queen Annes Lane NW',
        website: 'https://www.ginartdesign.com',
        photos: [{
            portrait: 'full',
            tour: {
                size: '100%',
                position: '100% 66%',
                padding: '90%'
            }
        }],
        // Defines the tour photo
        credit: 'Photo by Peter Maye',
        photo: {
            square: '1/square.jpg'
        },
        videos: [{
            name: 'Work',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'ORLANDO_DOMINGUEZ_ART_FINAL_854x480_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'ORLANDO_DOMINGUEZ_ART_FINAL_1280.mp4',
                    type: 'video/mp4'
                }]
            }]
        }, {
            name: 'Interview',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'ORLANDO_DOMINGUEZ_INT_FINAL_854x480_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'ORLANDO_DOMINGUEZ_INT_FINAL_1280.mp4',
                    type: 'video/mp4'
                }]
            }]
        }]
    }, {
        year: 2023,
        // Explicit ID to keep artist assets consistent
        id: 'rodney-buck-herring',
        artist: 'BUCK!',
        order: 10,
        name: 'With Due Thought & Careful Consideration',
        nophoto: false,
        description: 'With Due Thought & Careful Consideration is a heavily painted/detailed speaker’s lectern. A lectern’s purpose is to hold books or notes while the lecturer, preacher, professor, or activist speaks.This particular lectern’s purpose differs: it is to hold thought. Not a studied or thoughtless ideology spouted, not a passage or even scribbled idea blurted out to an audience, but the continued careful consideration of what does it mean to be at the lectern.',
        location: '915 26th St. NW',
        website: 'https://mbilashaka.com',
        photos: [{
            portrait: 'full',
            tour: {
                size: '100%',
                position: '100% 100%',
                padding: '125%'
            }
        }],
        // Defines the tour photo
        credit: 'Photo by Peter Maye',
        photo: {
            square: '1/square.jpg'
        },
        videos: [{
            name: 'Work',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'RODNEY_BUCK_HERRING_ART_FINAL_854x480_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'RODNEY_BUCK_HERRING_ART_FINAL_1280.mp4',
                    type: 'video/mp4'
                }]
            }]
        }, {
            name: 'Interview',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'RODNEY_BUCK_HERRING_INT_FINAL_854x480_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'RODNEY_BUCK_HERRING_INT_FINAL_1280.mp4',
                    type: 'video/mp4'
                }]
            }]
        }]
    }, {
        year: 2023,
        artist: 'Jabari Jefferson',
        order: 4,
        name: 'D.C. Stride, 5 Generation Strive: An Altar Piece',
        nophoto: false,
        description: 'As a fifth generation Washingtonian myself, the Metro was a foundational keystone in my upbringing in the city.  The Metro served as a passport that allowed me to have complete autonomy in navigation throughout my adolescence. Each Metro station was more than a destination but a crucial reference point in recognizing the diverse communities dispersed around the city. This sculpture pays respect to both my mother’s and father’s family ties that influenced the man I am today and is a reflection point for other DC natives.',
        location: '835 25th St. NW',
        website: 'https://www.jabaricjefferson.com',
        photos: [{
            portrait: 'full',
            tour: {
                size: '100%',
                position: '100% 50%',
                padding: '70%'
            }
        }],
        // Defines the tour photo
        credit: 'Photo by Peter Maye',
        photo: {
            square: '1/square.jpg'
        },
        videos: [{
            // NOTE: First name only here
            name: 'Work',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'JABARI_ART_FINAL_854x480_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'JABARI_ART_FINAL_1280.mp4',
                    type: 'video/mp4'
                }]
            }]
        }, {
            name: 'Interview',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'JABARI_JEFFERSON_INT_FINAL_854x480_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'JABARI_JEFFERSON_INT_FINAL_1280.mp4',
                    type: 'video/mp4'
                }]
            }]
        }]
    }, {
        year: 2023,
        artist: 'Kokayi',
        order: 12,
        name: 'Monolith',
        nophoto: false,
        description: 'This "Monolith" represents a place of affirmation and grounding for not only African Americans but all of those in and from the African diaspora. It is a balm to counter the ill effects of homogenization, erasure, and assimilation. The interior is inscribed with African aesthetics, Ghanaian Adinkra symbols and ancient Egyptian hieroglyphics, and topped by a hammered golden obelisk. Peering inside the glass pane embedded in the structure acts as a portal into another world, one both physically removed but psychically accessible.',
        location: '925 26th St. NW',
        website: 'https://www.kokayi202.com',
        photos: [{
            portrait: 'full',
            tour: {
                size: '100%',
                position: '100% 50%',
                padding: '70%'
            }
        }],
        // Defines the tour photo
        credit: 'Photo by Peter Maye',
        photo: {
            square: '1/square.jpg'
        },
        videos: [{
            name: 'Work',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'KOYAKI_ART_FINAL_854x480_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'KOYAKI_ART_FINAL_1280.mp4',
                    type: 'video/mp4'
                }]
            }]
        }, {
            name: 'Interview',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'KOYAKI_INT_FINAL_854x480_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'KOYAKI_INT_FINAL_1280.mp4',
                    type: 'video/mp4'
                }]
            }]
        }]
    }, {
        year: 2023,
        artist: 'Jacqui Maggi',
        order: 13,
        name: 'Balance',
        nophoto: false,
        description: 'The human subject, however absent as a form, is always present as the invisible spirit. During these days of turbulence, rush and uncertainty there is nothing more grounding than trying to find the right BALANCE for myself and for others. BALANCE represents the mental and emotional steadiness that makes life fulfilling and is deserved by all beings.',
        location: '909 Hughes Mews',
        website: '',
        photos: [{
            portrait: 'full',
            tour: {
                size: '100%',
                position: '100% 80%',
                padding: '70%'
            }
        }],
        // Defines the tour photo
        credit: 'Photo by Peter Maye',
        photo: {
            square: '1/square.jpg'
        },
        videos: [{
            name: 'Work',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'JACQUI_MAGGI_ART_FINAL_854x480_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'JACQUI_MAGGI_ART_FINAL_1280.mp4',
                    type: 'video/mp4'
                }]
            }]
        }, {
            name: 'Interview',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'JACQUI_MAGGI_INT_FINAL_854x480_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'JACQUI_MAGGI_INT_FINAL_1280.mp4',
                    type: 'video/mp4'
                }]
            }]
        }]
    }, {
        year: 2023,
        artist: 'Ayodele Mason',
        order: 9,
        name: 'Sanfoka 202',
        nophoto: false,
        description: 'The water bottles here focus the attention on recycling and upcycling materials into an art sculpture. The Adinkra symbol used, Sanfoka, means to learn from the past to give to the future. This message has a lot of impact and significance in my reality due to current global and local crises. Climate change is real and so are the positive impacts that we make.',
        location: '2532 I St. NW',
        website: '',
        photos: [{
            portrait: 'full',
            tour: {
                size: '100%',
                position: '100% 0%',
                padding: '82%'
            }
        }],
        // Defines the tour photo
        credit: 'Photo by Peter Maye',
        photo: {
            square: '1/square.jpg'
        },
        videos: [{
            name: 'Work',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'AYODELE_MASON_ART_FINAL_854x480_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'AYODELE_MASON_ART_FINAL_1280.mp4',
                    type: 'video/mp4'
                }]
            }]
        }, {
            name: 'Interview',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'AYODELE_MASON_INT_FINAL_854x480_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'AYODELE_MASON_INT_FINAL_1280.mp4',
                    type: 'video/mp4'
                }]
            }]
        }]
    }, {
        year: 2023,
        artist: 'Ajmal "MAS MAN" Millar',
        order: 5,
        name: 'ClubHouse (cricket)',
        nophoto: false,
        description: 'The ClubHouse was opened in 1975 to serve Black LGBTQ Washingtonians who were denied access at White LGBTQ establishments. It encouraged agency and freedom in its members. ClubHouse (cricket) is abstractly insectile and totemic in form.  It is a tribute to spaces that exist or existed to serve the community. The core of this piece is a seed feeder to signify the importance of spreading seeds of hope, ideas, food for the soul, and fortune around the globe.',
        location: '835 25th St. NW',
        website: 'http://www.artbyajmal.com',
        photos: [{
            portrait: 'full',
            tour: {
                size: '100%',
                position: '100% 0%',
                padding: '82%'
            }
        }],
        // Defines the tour photo
        credit: 'Photo by Peter Maye',
        photo: {
            square: '1/square.jpg'
        },
        videos: [{
            name: 'Work',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'AJMAL_MILLER_ART_FINAL_854x480_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'AJMAL_MILLER_ART_FINAL_1280.mp4',
                    type: 'video/mp4'
                }]
            }]
        }, {
            name: 'Interview',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'AJMAL_MILLER_INT_FINAL_854x480_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'AJMAL_MILLER_INT_FINAL_1280.mp4',
                    type: 'video/mp4'
                }]
            }]
        }]
    }, {
        year: 2023,
        artist: 'Angelique Scott',
        order: 2,
        name: 'Earthchild',
        nophoto: false,
        description: 'Being near water can soothe the soul and create space for reflection; reducing anxiety and stress. My fountain features carved elements and botanical reliefs. Elements include a signature Flower Child planter in addition to thrown vessels, clay cowrie shells, and wind chimes. It will be a catalyst to encourage visitors to take a mindfulness moment: to meditate and tend to their own inner garden.',
        location: '810 New Hampshire Ave. NW',
        website: '',
        photos: [{
            portrait: 'full',
            tour: {
                size: '100%',
                position: '100% 0%',
                padding: '82%'
            }
        }],
        // Defines the tour photo
        credit: 'Photo by Peter Maye',
        photo: {
            square: '1/square.jpg'
        },
        videos: [{
            name: 'Work',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'ANGELIQUE_SCOTT_ART_FINAL_854x480_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'ANGELIQUE_SCOTT_ART_FINAL_1280.mp4',
                    type: 'video/mp4'
                }]
            }]
        }, {
            name: 'Interview',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'ANGELIQUE_SCOTT_INT_FINAL_854x480_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'ANGELIQUE_SCOTT_INT_FINAL_1280.mp4',
                    type: 'video/mp4'
                }]
            }]
        }]
    }, {
        year: 2023,
        artist: 'Paul Steinkoenig',
        order: 7,
        name: 'Light in the Darkness',
        nophoto: false,
        // Use instead of single description field for multiple paragraphs
        descriptions: [
            'Statement: Light is our spiritual essence. Finding and following the light within is the altar of highest calling in my life. Both as an individual and as a community, following the light gives us purpose and brings us together. Creating and fostering working relationships with people has been a big part of careers in ministry, psychotherapy, and international diplomacy.',
            'Now as a sculptor, I consider the depiction of relationships as a form of art; my style is contemporary abstract.',
            'Materials: stainless steel elements and solar powered LED lights.',
            'Dimensions: 72” H x 32” W x 30” D'
        ],
        location: '2518 I St. NW',
        website: 'http://paulsteinkoenig.com',
        photos: [{
            portrait: 'full',
            tour: {
                size: '100%',
                position: '100% 20%',
                padding: '72%'
            }
        }],
        // Defines the tour photo
        credit: 'Photo by Peter Maye',
        photo: {
            square: '1/square.jpg'
        },
        videos: [{
            name: 'Work',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'PAUL_STEINKOENIG_ART_FINAL_854x480_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'PAUL_STEINKOENIG_ART_FINAL_1280.mp4',
                    type: 'video/mp4'
                }]
            }]
        }, {
            name: 'Interview',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'PAUL_STEINKOENIG_INT_FINAL_854x480_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'PAUL_STEINKOENIG_INT_FINAL_1280.mp4',
                    type: 'video/mp4'
                }]
            }]
        }]
    }, {
        year: 2023,
        artist: 'Paul Steinkoenig',
        order: 1,
        name: 'Lightness of Being',
        nophoto: false,
        descriptions: [
            'Statement: Each of us is on a spiritual and personal growth journey. Each person has their own values, lifestyle, personality, and genetic disposition. The best we can do is to open ourselves to new opportunities and grow as we engage in the next step in our own process of becoming.',
            'Creating and fostering working relationships with people has been central to my careers in ministry, psychotherapy, and international diplomacy. For many years, I enjoyed helping people solve problems and move toward more fulfilling lives.',
            'The cubes in Lightness of Being represent personality characteristics and spiritual growth. Each cube relates to one’s attitude and life phases. The higher on the column, the more open and transparent is the personality.',
            'Materials: welded steel frame with cubes made of steel, copper pipe, cherry wood, and glass bulbs. Many of the materials used in my works are recycled or salvaged.',
            'Dimensions: 158” H x 48” W x 48” D'
        ],
        location: '842 New Hampshire Ave. NW',
        website: 'http://paulsteinkoenig.com',
        photos: [{
            portrait: 'full',
            tour: {
                size: '100%',
                position: '100% 0%',
                padding: '127%'
            }
        }],
        // Defines the tour photo
        credit: 'Photo by Peter Maye',
        photo: {
            square: '1/square.jpg'
        },
        videos: [{
            name: 'Work',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'PAUL_STEINKOENIG_2_ART_FINAL_854x480_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'PAUL_STEINKOENIG_2_ART_FINAL_1280.mp4',
                    type: 'video/mp4'
                }]
            }]
        }, {
            name: 'Interview',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'PAUL_STEINKOENIG_INT_FINAL_854x480_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'PAUL_STEINKOENIG_INT_FINAL_1280.mp4',
                    type: 'video/mp4'
                }]
            }]
        }]
    }, {
        year: 2023,
        artist: 'Scott Benjamin Tucker',
        order: 8,
        name: "Mother Earth's Window",
        nophoto: false,
        description: 'The altar design in the spirit of The Day of the Dead, a multi-day Mexican holiday, evokes the family and friends who gather to pay respects and remember those loved ones who have died. This memorial event can take a humorous tone, as celebrants recount funny events and anecdotes about the departed. The female mask within can be animated by augmented reality creating pleasant and soothing expressions which can be altered during the exhibition.',
        location: '2520 I St. NW',
        website: '',
        photos: [{
            portrait: 'full',
            tour: {
                // The zoom factor on the background image
                size: '100%',
                // How far down to shift the start of the image in the frame
                position: '100% 0%',
                // How much of the image (what percentage of it) to show from the position to the bottom
                padding: '112%'
            }
        }],
        // Defines the tour photo
        credit: 'Photo by Peter Maye',
        photo: {
            square: '1/square.jpg'
        },
        videos: [{
            name: 'Work',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'SCOTT_BENJAMIN_TUCKER_ART_FINAL_854x480_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'SCOTT_BENJAMIN_TUCKER_ART_FINAL_1280.mp4',
                    type: 'video/mp4'
                }]
            }]
        }, {
            name: 'Process',
            sizes: [{
                width: 640,
                height: 360,
                formats: [{
                    file: 'Fogg bottom sculpture - SD 480p.mp4',
                    type: 'video/mp4'
                }]
            }]
        }, {
            name: 'Interview',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'SCOTT_BENJAMIN_TUCKER_INT_FINAL_854x480_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'SCOTT_BENJAMIN_TUCKER_INT_FINAL_1280.mp4',
                    type: 'video/mp4'
                }]
            }]
        }]
    }, {
        year: 2025,
        artist: 'Annie Broderick',
        order: 9,
        name: "Marianne",
        description: 'The sculpted metal piece resembles ribbons suspended in midair, playing with the material’s potential for duality—appearing soft and fluid while remaining rigid and strong. Drawing inspiration from the global impact of the Bauhaus movement in the early 20th century, and honoring the often-overlooked contributions of pioneering women both within the Bauhaus and in her own life, this piece explores how displacement can reshape artistic, cultural, and social landscapes. The piece also reflects the homeowner’s experience of hosting an exchange student from Eastern Europe, highlighting the significance of creating homes for others and embracing the role of a good host.',
        location: '915 26th St. NW',
        website: 'https://www.anniebroderick.com',
        about: [
            "Annie Broderick was born an artist and bred in needlework. Broderick's use of fabric and hand-stitching in her artwork honors the needlework tradition that runs through her maternal female ancestry. Broderick studied fine art with a focus on painting, earning her studio art degree from Davidson College. The artist then pursued her master's in Community Counseling from George Washington University for the purpose of working with adolescent girls. More recently, Broderick's devotion to her own physical power through her Olympic-style weightlifting practice has shaped and fueled her creative concepts and artistic process. Broderick's mission is to create power through art."
        ],
        // Defines the tour photo
        credit: 'Photo by Albert Ting',
        photo: {
            square: '1/square.jpg'
        },
        photos: [{
            portrait: 'square',
            tour: {
                // The zoom factor on the background image
                size: '100%',
                // How far down to shift the start of the image in the frame
                position: '100% 0%',
                // How much of the image (what percentage of it) to show from the position to the bottom
                padding: '112%'
            }
        }],
        videos: [{
            name: 'Interview',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'Annie Broderick_V4_PT_0425_FINAL_854x480_BS_MOBILE_UPDATE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'Annie Broderick_V4_PT_0425_FINAL_1280_UPDATE.mp4',
                    type: 'video/mp4'
                }]
            }]
        }]
    }, {
        year: 2025,
        artist: 'Brandon Hill',
        order: 14,
        name: "Big Plant 3",
        description: 'Inspired by the contrast between natural and industrial landscapes, Hill crafts steel renditions of the resilient Snake Plant. Native to tropical West Africa, this hardy species is known for thriving with minimal care and has become a common houseplant in the U.S., often distanced from its origins. By recreating it in steel, Hill emphasizes both its strength and its overlooked heritage, drawing parallels to the resilience of vulnerable communities. The bold colors infuse the work with vibrancy and joy, transforming the familiar into something striking and unexpected.',
        location: 'Snows Court',
        website: 'https://brandon-hill.art/',
        about: [
            "Brandon Hill (b. 1983, Baltimore, MD.; lives and works in Washington, DC) draws on his fascination with materiality, history, and the urban landscape to shape his multidisciplinary art practice. His work spans from 1\" sculptures made from lego to murals that wrap full buildings. His work is part of the permanent collection of the Reginald F. Lewis Museum and he has shown across the country. He is also a co-founder of No Kings Collective and Please Bring Chips."
        ],
        // Defines the tour photo
        credit: 'Photo by Albert Ting',
        photo: {
            square: '1/square.jpg'
        },
        photos: [{
            portrait: 'square',
            tour: {
                // The zoom factor on the background image
                size: '100%',
                // How far down to shift the start of the image in the frame
                position: '100% 0%',
                // How much of the image (what percentage of it) to show from the position to the bottom
                padding: '112%'
            }
        }],
        videos: [{
            name: 'Interview',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'Brandon Hill_V3_PT_0425_FINAL_854x480_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'Brandon Hill_V3_PT_0425_FINAL_1280.mp4',
                    type: 'video/mp4'
                }]
            }]
        }]
    }, {
        year: 2025,
        artist: 'Gerardo Camargo',
        order: 3,
        name: "Circles Growing",
        description: 'This sculptural installation is crafted mainly from arundinaria bamboo, a species native to the United States and found in Maryland, where the artist lives. Drawing inspiration from the circular forms embedded in the neighborhood (manhole covers, iron fences, street signs, etc.) the artist emphasizes this shape to reflect the surrounding environment. The circle, a symbol of cycles and return, reflects the continuous flow of time and lived experiences, emphasizing our interconnectedness and the ever-present possibility of finding our way back home.',
        location: '810 New Hampshire Ave. NW',
        website: 'https://www.instagram.com/gerardocamargoartist/?hl=en',
        about: [
            "Gerardo Camargo was born in Mexico City. He began working as a cartoonist at the age of 12. In 2004 he founded Zarco Gallery, an independent space for contemporary art that offered a program focused on involving the artist community with local processes in the society. In 2002 he was selected by the Mexican National Council for Culture and the Arts as a Promising Emerging Artist. His work has been shown in galleries and museums in Mexico and the United States, including: Latin Perspectives, Maryland Main Hall, Annapolis MD, 2022, Aceptar, Joan Hisaoka Healing Arts Gallery, Washington DC, 2020; Underlying Borders, Mexican Cultural Institute, Washington DC, 2019 After Eden, Siqueiros Museum, Morelos, Mexico, 2016. His art is part of numerous private collections as well as part of the permanent collection of the RISD Museum."
        ],
        // Defines the tour photo
        credit: 'Photo by Albert Ting',
        photo: {
            square: '1/square.jpg'
        },
        photos: [{
            portrait: 'square',
            tour: {
                // The zoom factor on the background image
                size: '100%',
                // How far down to shift the start of the image in the frame
                position: '100% 0%',
                // How much of the image (what percentage of it) to show from the position to the bottom
                padding: '112%'
            }
        }],
        videos: [{
            name: 'Interview',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'Gerardo Camargo_V3_PT_0425_FINAL_854x480_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'Gerardo Camargo_V3_PT_0425_FINAL_1280.mp4',
                    type: 'video/mp4'
                }]
            }]
        }]
    }, {
        year: 2025,
        artist: 'IceBox Collective',
        order: 1,
        name: "Nomadic House Project: La Casa de Benito",
        description: 'This installation reimagines traditional notions of home as a dynamic and adaptable form. As a visual representation of shelter, the house becomes a symbol of stability, uncertainty, and transience. It reflects on how the search for belonging is an evergreen endeavor, and urges viewers to reconsider the physical and emotional meanings of ""home"" in the context of today’s global challenges.  As a modular structure with interchangeable design, it evolves to explore different themes, stories, and purposes. This iteration reflects on the life of Benito Juárez, Mexico’s first Indigenous president, who abolished slavery and was forced into exile by an authoritarian regime, only to be welcomed in the U.S. Just blocks away stands a statue of Juárez, a gift from the Mexican people to the U.S., reinforcing the ongoing dialogue between solidarity, refuge, and the role of hospitality in shaping history.',
        location: '842 New Hampshire Ave. NW',
        website: 'https://iceboxcollective.com/',
        about: [
            "IceBox Collective is a community of creative alchemists dedicated to creating platforms for conscious conversations, sacred space for creative exchange, inspiration for civic engagement, and healing connections. Its members include: Courtney Applequist, Irene Clouthier Carrillo, and Edgar Endress."
        ],
        // Defines the tour photo
        credit: 'Photo by Albert Ting',
        photo: {
            square: '1/square.jpg'
        },
        photos: [{
            portrait: 'square',
            tour: {
                // The zoom factor on the background image
                size: '100%',
                // How far down to shift the start of the image in the frame
                position: '100% 0%',
                // How much of the image (what percentage of it) to show from the position to the bottom
                padding: '112%'
            }
        }],
        videos: [{
            name: 'Interview',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'IceBox Collective_V2_PT_0425_FINAL_854x480_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'IceBox Collective_V2_PT_0425_FINAL_1280.mp4',
                    type: 'video/mp4'
                }]
            }]
        }]
    }, {
        year: 2025,
        artist: 'Inga Adda',
        order: 7,
        name: "This is a performance, and you are the performer",
        description: 'Adda’s playful yard signs invite you to engage with the neighborhood and its surroundings in a lighthearted and participatory way. Poetic, irreverent, and humorous, each sign serves as a prompt that encourages spontaneous interactions, transforming the environment into a stage for creativity. Adda is interested in exploring how we relate to our surroundings, highlighting both the beauty and absurdity of human experiences. Through simple, yet thoughtful instructions, the signs turn everyday acts into moments of performance and reflection. The piece comes to life only when passers-by respond, blurring the line between art and life, and making each person an art performer. Whether through a whimsical gesture or a quiet meditation, Adda’s work highlights the importance of our interactions with the world around us, encouraging us to be open to spontaneous connections and new experiences.',
        location: '2518 I St. NW and 2520 I St. NW',
        website: 'https://www.ingaadda.com',
        about: [
            "Inga Adda (b. Washington, DC) is a textile artist living and working out of Maryland. In 2020 she received her BFA in Fiber from the Maryland Institute College of Art (MICA) in Baltimore, MD. Adda works in traditional fiber material techniques such as weaving, quilting, and sewing as well as photography to create work that is often poetic and other times irreverent or humorous in nature. She is interested in exploring themes relating to the environment and how we relate to our surroundings, as well as the absurdity of the human experience. Adda is the first generation in her family born in the U.S. and is of Icelandic and Peruvian/Bolivian descent. Growing up, she was exposed to Icelandic design and traditional Peruvian and Bolivian tapestries and sculpture through her mother’s personal art collecting and traveI. It is through these experiences and exposures that she bases her visual language and aesthetic of her work."
        ],
        // Defines the tour photo
        credit: 'Photo by Albert Ting',
        photo: {
            square: '1/square.jpg'
        },
        photos: [{
            portrait: 'square',
            tour: {
                // The zoom factor on the background image
                size: '100%',
                // How far down to shift the start of the image in the frame
                position: '100% 0%',
                // How much of the image (what percentage of it) to show from the position to the bottom
                padding: '112%'
            }
        }],
        videos: [{
            name: 'Interview',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'Inga Adda_V3_PT_0425_FINAL_854x480_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
             }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'Inga Adda_V3_PT_0425_FINAL_1280.mp4',
                    type: 'video/mp4'
                }]
            }]
        }]
    }, {
        year: 2025,
        artist: 'Jean Jinho Kim',
        order: 11,
        name: "Magic Boot (IFS-FP-1)",
        description: "This sculpture from Kim's Magic Boot Series draws from Geometric Abstraction and Neo-Conceptualism to celebrate human resilience while exploring life’s dichotomies. Inspired by her mother’s unwavering spirit, this piece transforms the humble boot into a symbol of choice, challenge, and strength. The refined shape and bold color honors the spirit of mothers, weaving personal narratives with universal themes of perseverance and evolution. Kim’s piece reflects the transformative process of migration, where personal stories of endurance and resilience reshape identity and cultivate a sense of belonging in new spaces. The boot, both a practical object and a symbol of journey, embodies the duality of movement and settlement, preservation and adaptation.",
        location: '2538 Queen Annes Lane',
        website: 'https://www.jeanjinhokim.com/',
        about: [
            "Jean Jinho Kim was born in Seoul, South Korea. She earned her BFA in painting from West Virginia University in Morgantown and received her MFA in studio art at American University in Washington, DC. Throughout the early 2010s Jean Kim moved away from painting and began experimenting with found art and mixed media. She began using ordinary household items that were seemingly insignificant and began transforming them into something extraordinary through her art. The idea of transformation, validation, and empowerment is present throughout all of her work and continues to be a source of her inspiration. After the 2020 pandemic, her medium drastically became more figurative and focused on the conceptual transformation of ideas through her art. Though the medium has changed, the idea of transformation and empowerment became more direct and potent."
        ],
        // Defines the tour photo
        credit: 'Photo by Albert Ting',
        photo: {
            square: '1/square.jpg'
        },
        photos: [{
            portrait: 'square',
            tour: {
                // The zoom factor on the background image
                size: '100%',
                // How far down to shift the start of the image in the frame
                position: '100% 0%',
                // How much of the image (what percentage of it) to show from the position to the bottom
                padding: '112%'
            }
        }],
        videos: [{
            name: 'Interview',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'Jean_Jinho_Kim_PT_V4_0425_FINAL_854x480_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'Jean_Jinho_Kim_PT_V4_0425_FINAL_1280.mp4',
                    type: 'video/mp4'
                }]
            }]
        }]
    }, {
        year: 2025,
        artist: 'Jordan Hamlett Sanders',
        order: 2,
        name: "Meridian Light Observatory",
        description: "Drawing inspiration from compasses, globes, and navigational tools, Jordan Hamlett Sanders creates mixed-media kinetic sculptures that evoke the themes of migration, adventure, and the pursuit of new beginnings. The sturdy frame provides a sense of stability, while the movement of the sculpture speaks to the ebb and flow of life's journey: always shifting, never static. This kinetic nature mirrors the fluidity and uncertainty of migration, highlighting the ongoing process of adaptation and discovery. The piece also honors the artist’s grandmother, Bridget O'Day, who migrated from Ireland to the U.S. and settled in the Foggy Bottom neighborhood, further connecting the artwork to the community and the legacy of those who have journeyed in search of a new life.",
        location: '834 New Hampshire Ave. NW',
        website: 'https://www.jordanhamlettsanders.com/',
        about: [
            "Jordan Hamlett Sanders, a native of Gaithersburg, Maryland, earned his Master of Arts from the Corcoran College of Art & Design. His artistic practice delves into the boundaries and intersections of artifact and technology. Using metals, glass, and technological detritus, Sanders employs a variety of industrial processes and intuitive techniques to craft both freestanding and wall-mounted sculptures."
        ],
        // Defines the tour photo
        credit: 'Photo by Albert Ting',
        photo: {
            square: '1/square.jpg'
        },
        photos: [{
            portrait: 'square',
            tour: {
                // The zoom factor on the background image
                size: '100%',
                // How far down to shift the start of the image in the frame
                position: '100% 0%',
                // How much of the image (what percentage of it) to show from the position to the bottom
                padding: '112%'
            }
        }],
        videos: [{
            name: 'Interview',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'Jordan Hamlett Sanders_V3_PT_0425_FINAL_854x480_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'Jordan Hamlett Sanders_V3_PT_0425_FINAL_1280.mp4',
                    type: 'video/mp4'
                }]
            }]
        }]
    }, {
        year: 2025,
        artist: 'Miguel Braceli',
        order: 8,
        name: "Libertad o Muerte",
        description: 'This flag installation powerfully captures the tension between ideals of freedom and the divisions imposed by borders and nationalities. The rich green color evokes the earth and nature, symbolizing a universal connection that transcends geographical boundaries and reminding us of our shared humanity. Embroidered with the words "Libertad o Muerte" (Freedom or Death), the flag pays homage to the struggles and sacrifices made by people throughout history in their quest for dignity and basic human rights. The piece serves as both a tribute to their resilience and a stark reminder of the ongoing, global fight for liberty and justice. By bringing these themes to the forefront, Braceli challenges us to reflect on how easily freedom can be taken for granted, and the lengths people will go to in its defense.',
        location: '26th and I St. NW',
        website: 'https://www.miguelbraceli.com/',
        about: [
            "Miguel Braceli is a multidisciplinary artist working at the intersection between art, architecture, and education. His practice is focused on participatory projects in public space. Most of these projects have been large-scale works, developed in countries such as Argentina, Bolivia, Chile, Costa Rica, México, Spain, Sweden, United States, and Venezuela. He explores notions of borders, migrations, national identities, and social-political conflicts, working from the geopolitical geography to a human scale. Braceli’s collective performances have been presented in Matadero Madrid, LABoral Centro de Arte y Creación Industrial (Asturias), and the University Museum of Contemporary Art (Mexico City). His most recent recognitions include a Tulsa Artist Fellowship, MacDowell Fellowship, Art Residencies at Fountainhead and Skowhegan School of Painting and Sculpture, and a New York City Department of Cultural Affairs Permanent public art commission for the Dalton Recreation Center in Staten Island."
        ],
        // Defines the tour photo
        credit: 'Photo by Albert Ting',
        photo: {
            square: '1/square.jpg'
        },
        photos: [{
            portrait: 'square',
            tour: {
                // The zoom factor on the background image
                size: '100%',
                // How far down to shift the start of the image in the frame
                position: '100% 0%',
                // How much of the image (what percentage of it) to show from the position to the bottom
                padding: '112%'
            }
        }],
        videos: [{
            name: 'Interview',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'Miguel Braceli_V3_PT_0425_FINAL_854x480_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'Miguel Braceli_V3_PT_0425_FINAL_1280.mp4',
                    type: 'video/mp4'
                }]
            }]
        }]
    }, {
        year: 2025,
        artist: 'Neha Misra',
        caption: 'Photo by Senna Ahmad',
        order: 5,
        name: "Migratory Refuge of Birds, Trees & Poetry: Sacred Tree Grove",
        description: "This piece embodies Misra's commitment to bridging individual, collective, and planetary healing through eco-folk traditions, mythology, and the rich cultural tapestry of her Indian heritage. This immersive installation celebrates migratory beings in symbiotic relationships with trees and poetry, weaving together elements of the natural world and human experiences. Inspired by the artist’s South Asian lineage and first-generation immigrant perspective, the grove immerses viewers in deep blues, reflecting the vastness of our shared planet. Through this collaborative creation with the land, Misra invites reflection on the growing impacts of climate change on migratory beings, urging a deeper awareness of our interconnectedness and the need for global care and action.",
        location: '835 25th St. NW',
        website: 'https://www.nehamisrastudio.com/',
        about: [
            "Neha Misra नेहा मिश्रा (she/her) is an award-winning eco-folk artist, poet, and climate justice advocate. Her Mother Earth wisdom-centered studio embodies the transformative power of art to build bridges between private, collective, planetary healing, and justice. Neha's practice is rooted in her heritage as a first-generation, multi-lingual immigrant woman from New Delhi, India, who calls a solar-powered intentional community in the Washington DC. metropolitan region her beloved adopted home. She is a recipient of Nootana Washington DC’s 2024 “Preronadayini/Inspiration Giver” Distinguished Creative Leadership Award. Neha is 2023-2025 Hamiltonian Artists Fellow and 2022 Public Voices Fellow on the Climate Crisis—an initiative of the Yale Program on Climate Change Communication and the OpEd Project to change who writes history. She serves as the inaugural Global Ambassador of nonprofit Remote Energy to make solar jobs more accessible for communities of color, especially women."
        ],
        // Defines the tour photo
        credit: 'Photo by Albert Ting',
        photo: {
            square: '1/square.jpg'
        },
        photos: [{
            portrait: 'square',
            tour: {
                // The zoom factor on the background image
                size: '100%',
                // How far down to shift the start of the image in the frame
                position: '100% 0%',
                // How much of the image (what percentage of it) to show from the position to the bottom
                padding: '112%'
            }
        }],
        videos: [{
            name: 'Interview',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'Neha Misra_V3_PT_0425_FINAL_854x480_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'Neha Misra_V3_PT_0425_FINAL_1280.mp4',
                    type: 'video/mp4'
                }]
            }]
        }]
    }, {
        year: 2025,
        artist: 'Njena Surae Jarvis',
        order: 6,
        name: "An Allegory of Sunshine and Shadow",
        description: 'This site-specific installation explores the delicate balance between light and shadow, separation and connection. Using architectural forms, the sculpture creates a sense of familiarity while blurring the lines between inside and outside spaces. The layered fiberglass screen symbolizes memory’s depth, while the mirrored dichroic shapes reflect sunlight, casting vibrant colors during the day. At night, the installation glimmers like stars, changing as viewers move around it. The play of light acts as a metaphor for how memory, beauty, and connection can transcend the illusion of separation. By encouraging us to rethink how private and shared spaces intersect, this piece speaks to the complexities of place, identity, and memory for immigrants and diasporic communities. Through this work, visitors are invited to experience a moment of unity amidst a fragmented world.',
        location: '835 25th St. NW',
        website: 'https://almalewis.org/njena-surae-jarvis/',
        about: [
            "Njena Surae Jarvis is a multidisciplinary artist working across painting, sculpture, music, and writing, exploring history's material and psychic resonance. Her practice engages ancestral connections, spatial memory, and material alchemy. Educated at the Duke Ellington School of the Arts and The Cooper Union for the Advancement of Science and Art (BFA), she reimagines historical narratives through innovative methodologies. Her sculptural and installation-based works incorporate electroforming copper, wet forming vegetable-tanned leather, and crystallization. E.GUN.GUN, a wet-formed bison leather masquerade vestige honoring the Black Panthers, and an astrolabe solar calendar at Dorothy Height Elementary School reflect her focus on preservation and spatial consciousness. She has exhibited at Woodlawn Plantation and Frank Lloyd Wright's Pope-Leighey House, the August Wilson Center, the National Portrait Gallery, and the Katzen Arts Center. In collaboration with her mother, Martha Jackson Jarvis, she creates public installations merging science, spirituality, and material knowledge, fostering a dialogue between past and present."
        ],
        // Defines the tour photo
        credit: 'Photo by Albert Ting',
        photo: {
            square: '1/square.jpg'
        },
        photos: [{
            portrait: 'square',
            tour: {
                // The zoom factor on the background image
                size: '100%',
                // How far down to shift the start of the image in the frame
                position: '100% 0%',
                // How much of the image (what percentage of it) to show from the position to the bottom
                padding: '112%'
            }
        }],
        videos: [{
            name: 'Interview',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'Njena Surae Jarvis_V3_PT_0425_FINAL_854x480_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'Njena Surae Jarvis_V3_PT_0425_FINAL_1280.mp4',
                    type: 'video/mp4'
                }]
            }]
        }]
    }, {
        year: 2025,
        artist: 'Rose Jaffe',
        order: 4,
        name: "Bonding",
        description: 'Jaffe’s sculpture brings to life a group of figures engaged in a dynamic interplay of support, tension, and mutual reliance. As they sustain each other, they vividly represent the complexities and interdependence of solidarity within a community. The piece’s light, whimsical forms invite a closer look at the deeper themes of unity, collaboration, and the essential role of mutual support. The steel construction, strong and resistant, speaks to the unyielding power of collective action, reminding us of the strength that emerges when people come together. Through this work, Jaffe highlights the importance of community ties and the transformative impact of working in unison for the common good.',
        location: '826 25th St. NW',
        website: 'https://rosejaffe.myportfolio.com/',
        about: [
            "Rose Jaffe is a visual artist based in Washington, DC. Her mediums span mural painting, printmaking, and digital illustration. Rose earned her BFA at The University of Michigan and has pursued an art career full time after teaching middle and high school art in the city.  She has painted over 30 murals nationally and internationally, including over 20 in her hometown of Washington. Her art has been featured in over 15 publications, including the Washington Post, City Paper, NBC, and CNN among others. Rose’s work is vibrant and often playful, with themes of political activism, natural healing, and spiritual grounding. She is dedicated to harnessing the power of art to spark conversation, build connection, and create social change."
        ],
        // Defines the tour photo
        credit: 'Photo by Albert Ting',
        photo: {
            square: '1/square.jpg'
        },
        photos: [{
            portrait: 'square',
            tour: {
                // The zoom factor on the background image
                size: '100%',
                // How far down to shift the start of the image in the frame
                position: '100% 0%',
                // How much of the image (what percentage of it) to show from the position to the bottom
                padding: '112%'
            }
        }],
        videos: [{
            name: 'Interview',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'Rose_Jaffe_V3_PT_042025_FINAL_854x480_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'Rose_Jaffe_V3_PT_042025_FINAL_1280.mp4',
                    type: 'video/mp4'
                }]
            }]
        }]
    }, {
        year: 2025,
        artist: 'Steve Wanna',
        order: 12,
        name: "To be Filled with Light, and to Shine",
        description: 'Wanna delves into the complexities of belonging through the interplay of light, transparency, and opacity. The cube, with its simple geometric form, symbolizes both the possibility and the limitations of space and community building. Just as light flows through the sculpture, illuminating different aspects of its structure at various times of the day, our sense of belonging can shift and transform depending on external factors, internal emotions, and the passage of time. The piece invites contemplation on how we navigate spaces that may seem open yet remain difficult to truly enter or understand. It reflects the paradox of feeling drawn to a place or group, while also being confronted by the invisible boundaries that prevent us from fully integrating. The sculpture, at moments fully translucent and at other times clouded, offers a visual metaphor for the nuanced and often uncertain experience of seeking and finding a sense of belonging.',
        location: '925 26th St. NW',
        website: 'https://www.stevewanna.com/',
        about: [
            "Steve Wanna is a multi-disciplinary sound and visual artist whose work includes music, sound design for dance collaborations, sculpture, installation, photography, and works for mixed media. His art showcases the hidden, often ignored beauty he finds in chaotic and seemingly random phenomena. Using science, philosophy, and comparative mythology to create abstract, experimental, and multimedia work that imagines possibilities for new beginnings. Born and raised in Lebanon, Wanna immigrated to the US with his family as a teenager. He holds a doctorate in Music Composition from the University of Maryland. Wanna’s works have been presented at venues and galleries at home and abroad. Recent exhibitions include a two-person show at the Delaware Contemporary titled Inquiry: At The Intersection of Curiosity, which featured an installation of eight kinetic sound sculptures from his ongoing series Inner Spaces, and a solo show titled Transparent to Transcendence at Touchstone Gallery in Washington, DC (reviewed in the Washington Post). His immersive, spatiotemporal, site-specific installation A Vast Expanse was selected for the Museum of Contemporary Art Arlington SOLOS 2023 and installed at the museum. Ferns, scrawned black, an outdoor sound installation was presented at The Kreeger Museum in Washington DC in 2024."
        ],
        // Defines the tour photo
        credit: 'Photo by Albert Ting',
        photo: {
            square: '1/square.jpg'
        },
        photos: [{
            portrait: 'square',
            tour: {
                // The zoom factor on the background image
                size: '100%',
                // How far down to shift the start of the image in the frame
                position: '100% 0%',
                // How much of the image (what percentage of it) to show from the position to the bottom
                padding: '112%'
            }
        }],
        videos: [{
            name: 'Interview',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'Steeve Wanna_V3_PT_04202_FINAL_854x480_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'Steeve Wanna_V3_PT_04202_FINAL_1280.mp4',
                    type: 'video/mp4'
                }]
            }]
        }]
    }, {
        year: 2025,
        artist: 'Victor Ekpuk',
        order: 13,
        name: "Prophet’s Coat",
        description: 'This piece reimagines the ancient Nigerian communication system, Nsibidi, to address themes of historical narratives, the contemporary African diaspora, and humanity’s connection to the sacred. It stands out not only as a sculpture but also as the negative space it formed by the creation of a different artwork. Ekpuk carved a form out, and the resulting "emptiness" becomes a new piece itself. This absence is not a void in meaning, but rather a space that holds significance, symbolizing the unseen, the untold. By highlighting negative space, Ekpuk draws attention to the importance of both presence and absence in communication, suggesting that what is not immediately visible or spoken also carries weight in shaping history and memory.',
        location: '909 Hughes Mews',
        website: 'https://www.victorekpuk.com/',
        about: [
            "Victor Ekpuk is an internationally-renowned Nigerian-American artist based in Washington, DC. His paintings, drawings, and sculptures reimagine the ancient Nigerian communication system, Nsibidi, to explore a diverse spectrum of meaning addressing historical narratives, the contemporary African diaspora, and humanity’s connection to the sacred. Ekpuk’s three-decade-long career has earned his works inclusion in numerous prestigious collections, including the Smithsonian National Museum of African American History and Culture; Smithsonian National Museum of African Art; Boston Museum of Fine Art; The World Bank; Bank ABC (Arab Bank Corporation) in the Kingdom of Bahrain; Kiran Nadar Museum of Art in New Delhi; Elizabeth Miller Sculpture Center; Hood Museum; Krannert Art Museum; Newark Museum; United States Art in Embassies Art Collection. In recent years, Ekpuk has added large-scale murals, installations, and public art projects to his portfolio. He has been commissioned by The Phillips Collection, Washington DC, North Carolina Museum of Art, Memphis Brooks Museum, Washington DC city government for Boone Elementary School, and Bank ABC (Arab Bank Corporation)."
        ],
        // Defines the tour photo
        credit: 'Photo by Albert Ting',
        photo: {
            square: '1/square.jpg'
        },
        photos: [{
            portrait: 'square',
            tour: {
                // The zoom factor on the background image
                size: '100%',
                // How far down to shift the start of the image in the frame
                position: '100% 0%',
                // How much of the image (what percentage of it) to show from the position to the bottom
                padding: '112%'
            }
        }],
        videos: [{
            name: 'Interview',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'Victor Ekpuk_V3_PT_0425_FINAL_854x480_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'Victor Ekpuk_V3_PT_0425_FINAL_1280.mp4',
                    type: 'video/mp4'
                }]
            }]
        }]
    }, {
        year: 2025,
        artist: 'Xena Ni',
        order: 10,
        name: "may you flourish in many futures / may many futures flourish because of you",
        description: 'The signs evoke the power of language as a vessel for intention. These illuminated wishes radiate a quiet yet potent energy, reflecting themes of hope, interconnectedness, and cyclical potential. Ni meditates on the unimagined futures of her ancestors and the opportunities now available to her, acknowledging the historical struggles and legacies of Asian communities in the United States. The piece also suggests the existence of multiple realities that emerge through our interactions with one another, emphasizing the importance of being an agent of change and supporting the flourishing of others. Through her work, Ni invites viewers to reflect on the interdependence of their actions and the futures they help shape.',
        location: '915 26th St. NW',
        website: 'https://www.madebyxena.com/',
        about: [
            "Xena Ni is a socially engaged artist who leverages time travel, public archives, and immersive, interactive experiences to bring forward narratives often obscured by history, policy, and societal neglect. Her participatory art installations delve into themes of identity, the equity of public benefits, the inconsistencies within federal regulations, and the role luck plays in American lives. Through these explorations, she challenges viewers to confront overlooked systems and consider alternative narratives. Ni’s work has garnered attention from major media outlets, including The Washington Post, The Boston Globe, Hyperallergic, and Bloomberg. Her installations have been exhibited at respected venues like the Fuller Craft Museum in Massachusetts, Contemporary Craft in Pittsburgh, the Ohio Craft Museum, Kunstraum in Brooklyn, and as part of the Data Through Design exhibition in New York City."
        ],
        // Defines the tour photo
        credit: 'Photo by Albert Ting',
        photo: {
            square: '1/square.jpg'
        },
        photos: [{
            portrait: 'square',
            tour: {
                // The zoom factor on the background image
                size: '100%',
                // How far down to shift the start of the image in the frame
                position: '100% 0%',
                // How much of the image (what percentage of it) to show from the position to the bottom
                padding: '112%'
            }
        }],
        videos: [{
            name: 'Interview',
            sizes: [{
                width: 854,
                height: 480,
                formats: [{
                    file: 'Xena Ni_V3_PT_0425_FINAL_854x480_BS_MOBILE.mp4',
                    type: 'video/mp4'
                }]
            }, {
                width: 1280,
                height: 720,
                formats: [{
                    file: 'Xena Ni_V3_PT_0425_FINAL_1280.mp4',
                    type: 'video/mp4'
                }]
            }]
        }]
    }];
    // The artist photo can incorporate an additional caption for credit
    // See: Neha Misra for an example.  Search for: caption:

    // Augment with id and image if needed
    _.forEach(WORKS, function(w) {
        if( ! w.id) {
            w.id = _.kebabCase(w.artist);
        }

        if( ! w.sort) {
            var lastSpace = w && w.artist && w.artist.lastIndexOf(' ');
            w.sort = lastSpace > -1 && lastSpace + 1 < _.size(w.artist) ?
                w.artist.substring(lastSpace + 1) : w.artist;
        }

        for(var x = 0, z = _.size(w.photos); x < z; x++) {
            w.photos[x].id = x + 1;
        }

        if( ! w.image) {
            if(_.size(w.photos)) {
                w.image = w.order + '/1/full.jpg';
            }
            else if(w.name) {
                w.image = _.chain(w.name)
                .deburr()
                .words()
                .join('-')
                .value() + '-' + w.year + '.jpg';
            }
        }

    });

    var query = function(params) {
        return _.chain(WORKS)
        .filter(function(w) {
            return ( ! (params && params.year)) ||
                (params && params.year && params.year == w.year);
        })
        .filter(function(w) {
            return ( ! (params && params.id)) ||
                (params && params.id && params.id == w.id);
        })
        .sortBy(function(w) {
            return (w && w.year || '0000') + (w && w.sort);
        })
        .value();
    };
    this.query = query;

    var artistCount = function(params) {
        return _.chain(query(params))
        .map('artist')
        .map(_.toLower)
        .map(function(a) {
            return a && a.split(' and ');
        })
        .flatten()
        .uniq()
        .size();
    };
    this.artistCount = artistCount;

}])
.service('PageTitle', [function() {
    var pageTitle = '';

    this.set = function(title) {
        pageTitle = _.isFunction(title) ? title() : title;
    };

    this.get = function() {
        return pageTitle || '';
    };

}])
.service('News', ['Work', 'Exhibition', function(Work, Exhibition) {
    var NEWS = [{
        artists: ['emily-fussner', 'alan-binstock'],
        organization: 'Washington Sculptor’s Group',
        title: 'Shadowlands',
        description: "Artists Emily Fussner and Alan Binstock featured in Washington Sculptor's Group: Shadowlands.",
        type: 'group',
        website: 'https://www.acp.org/',
        dates: {
            start: '2018-10-23',
            end: '2019-04-12'
        },
        venue: {
            name: 'The American Center for Physics',
            address: '1 Physis Ellipse, College Park, MD 20740'
        },
        events: [ ]
    }, {
        artists: ['nancy-frankel'],
        organization: '',
        title: 'Nancy at Ninety: A Retrospective of Form and Color',
        description: "This retrospective of seven decades of the work of Washington, DC sculptor Nancy Frankel celebrates her ninetieth birthday in 2019. Working in various media since the 1950s—including wood, Plexiglas, plaster, design cast, and steel—Frankel has explored a fundamentally geometric vocabulary, often with a sense of playfulness. In addition to her freestanding works in three dimensions, a few of her many graphite drawings and tempera paintings will be represented, as well as one of her large wall reliefs. Curated by Claudia Rousseau.",
        type: 'individual',
        website: 'https://www.american.edu/cas/museum/2019/Nancy-at-Ninety.cfm',
        dates: {
            start: '2019-01-26',
            end: '2019-03-17'
        },
        venue: {
            name: 'American University Museum',
            address: '4400 Massachusetts Ave NW Washington, DC 20016-8031'
        },
        events: []
    }, {
        artists: ['barbara-liotta'],
        organization: '',
        title: 'The Gifts of Tony Podesta',
        description: "The first major exhibition drawn from the Corcoran Legacy Collection features strong and provocative photography and sculpture donated by Tony Podesta over the past decade to the Corcoran Gallery of Art, now part of the American University Museum's holdings.  Liotta's work is part of this collection and exhibition.",
        type: 'group',
        website: 'https://www.american.edu/cas/museum/2019/Gifts-of-Tony-Podesta.cfm/',
        dates: {
            start: '2019-01-26',
            end: '2019-03-17'
        },
        venue: {
            name: 'American University Museum',
            address: '4400 Massachusetts Ave NW Washington, DC 20016-8031'
        },
        events: []
    }, {
        artists: ['craig-kraft'],
        organization: '',
        title: 'Philadelphia Fine Art Fair',
        description: 'Artist Craig Kraft will be featured in a one person exhibition at the entrance to the Philadelphia Fine Art Fair.',
        type: 'group',
        website: 'https://www.philfineartfair.com/',
        dates: {
            start: '2019-04-04',
            end: '2019-04-07'
        },
        venue: {
            name: '23rd St. City Troop Armory',
            address: '22 S 23rd St, Philadelphia, PA 19103'
        },
        events: []
    }, {
        artists: ['template'],
        organization: '',
        title: '',
        description: '',
        type: 'individual',
        website: '',
        dates: {
            start: '',
            end: ''
        },
        venue: {
            name: '',
            address: ''
        },
        events: [{
            name: '',
            date: '',
            start: 0000,
            end: 0000
        }]
    }, {
        artists: ['craig-kraft'],
        organization: '',
        title: 'A 24 Year Retrospective',
        description: '',
        type: 'individual',
        website: 'https://www.washingtonpost.com/entertainment/museums/in-the-galleries-hard-and-soft-juxtaposes-the-delicate-and-the-durable/2018/11/16/89db8526-e6a0-11e8-b8dc-66cca409c180_story.html',
        dates: {
            start: '',
            end: '2018-12-28'
        },
        venue: {
            name: 'Susan Calloway Fine Art Gallery',
            address: '1643 Wisconsin Ave NW Washington DC 20007'
        },
        events: [{
            name: 'Opening Reception',
            date: '2019-11-30',
            start: 1800,
            end: 2000
        }]
    }, {
        artists: ['dalya-luttwak'],
        organization: '',
        title: 'Finding a Path',
        description: '',
        type: 'group',
        website: 'https://www.american.edu/cas/museum/2018/finding-a-path.cfm',
        dates: {
            start: '2018-09-04',
            end: '2018-12-28'
        },
        venue: {
            name: 'Katzen Art Center',
            address: '4400 Massachusetts Ave NW Washington DC 20016'
        },
        events: [ ]
    }, {
        curators: ['deirdre-ehlen-mac-williams'],
        organization: '',
        title: 'Georgetown Glow',
        description: 'Curator Deirdre Ehlen MacWilliams has curated Georgetown Glow for the fifth time.',
        type: 'individual',
        website: 'http://www.georgetownglowdc.com/',
        dates: {
            start: '2018-12-01',
            end: '2019-01-06'
        },
        venue: {
            name: 'Multiple outdoor locations throughout Georgetown',
            address: 'Georgetown Washington DC 20016'
        },
        events: [ ]
    }, {
        organization: '',
        title: 'Loud Silence: Expressions of Activism',
        description: 'Advisory Committee Member Helen Zughaib featured in two exhibitions.',
        type: 'group',
        website: 'https://www.wilkes.edu/arts/sordoni-art-gallery/past-exhibitions/loud-silence.aspx',
        dates: {
            start: '2018-10-23',
            end: '2018-12-16'
        },
        venue: {
            name: 'Sordoni Art Gallery at Wilkes University',
            address: '141 South Main Street Wilkes-Barre PA 18701'
        },
        events: [ ]
    }, {
        organization: 'Library of Congress',
        title: 'Art in Action: Herblock and Fellow Artists Respond to Their Times',
        description: 'Advisory Committee Member Helen Zughaib featured Library of Congress Exhibit.',
        type: 'group',
        website: 'https://www.loc.gov/exhibitions/herblock-art-in-action/about-this-exhibition/',
        dates: {
            start: '2019-01-31',
            end: '2019-08-17'
        },
        venue: {
            name: 'Graphic Arts Galleries, Ground Floor, Thomas Jefferson Building',
            address: '10 First St SE, Washington, DC 20540'
        },
        events: [ ]
    }, {
        organization: 'Gallery Al-Quds',
        title: 'Syrian Migration Series',
        description: "In her most recent work, Advisory Committee Member Helen Zughaib creates a series of paintings inspired by the narrative paintings of Jacob Lawrence's Migration series from 1940-1941, a visual record of the great migration of African Americans from the south to the north. Zughaib's Syrian Migration Series begins with the initial uprisings of the \"Arab Spring\" and its aftermath, the Syrian civil war and subsequent displacement of millions of people and a following refugee crisis that continues to affect the Arab world, Europe and the United States.",
        type: 'individual',
        website: 'https://www.thejerusalemfund.org/the-gallery',
        dates: {
            start: '2019-01-25',
            end: '2019-03-08'
        },
        venue: {
            name: 'Jerusalem Fund',
            address: '2425 Virginia Ave NW, Washington, DC 20037'
        },
        events: [ ]
    }];

    var curators = _.chain(Exhibition.query())
    .map('curators')
    .flatten()
    .uniqBy('id')
    .value();

    var artists = _.chain(Work.query())
    .uniqBy('id')
    .value();

    _.forEach(NEWS, function(n) {
        n.id = _.truncate(_.kebabCase(n.desc));

        n.curators = _.map(n.curators, function(c) {
            return _.find(curators, { id: c }) || { id: c, curator: c };
        });

        n.artists = _.map(n.artists, function(a) {
            return _.find(artists, { id: a }) || { id: a, artist: a };
        });
    });

    var keyFn = function(i) {
        return i && i.dates && i.dates.end;
    };
    var query = function(params) {
        return _.chain(NEWS)
        .filter(keyFn) // Must have an end date
        .orderBy([keyFn], ['desc'])
        .value();
    };
    this.query = query;

}])
.service('Video', [ 'Device', function(Device) {
    var selectSize = function(sizes) {
        /*
        var vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        var vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
        */
        var mobile = Device.hasTouchScreen();
        var result = undefined;

        if(mobile) {
            result = _.find(sizes, { height: 480 });
        }

        if( ! result) {
            result = _.find(sizes, { height: 720 });
        }

        if( ! result) {
            result = _.head(sizes);
        }

        return result;
    };
    this.selectSize = selectSize;

    var play = function(name, videos, xform) {
        // Find the video or bail
        var video = _.find(videos, { name: name });
        if( ! video) {
            return undefined;
        }

        // Pick a size
        var size = selectSize(video.sizes);
        var sources = _.map(size.formats, function(s) {
            return xform(s, video);
        });

        // Did we find a video, size and suitable sources?
        if( ! (video && _.size(sources))) {
            return undefined;
        }

        return {
            sources: sources,
            video: video
        };
    };
    this.play = play;
}])
.service('Device', [ function() {
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent
    var hasTouchScreen = function() {
        var result = false;
        if ("maxTouchPoints" in navigator) {
            result = navigator.maxTouchPoints > 0;
        } else if ("msMaxTouchPoints" in navigator) {
            result = navigator.msMaxTouchPoints > 0;
        } else {
            var mQ = window.matchMedia && matchMedia("(pointer:coarse)");
            if (mQ && mQ.media === "(pointer:coarse)") {
                result = !!mQ.matches;
            } else if ('orientation' in window) {
                result = true; // deprecated, but good fallback
            } else {
                // Only as a last resort, fall back to user agent sniffing
                var UA = navigator.userAgent;
                result = (
                    /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) ||
                    /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA)
                );
            }
        }
        return result;
    };
    this.hasTouchScreen = hasTouchScreen;

    var scrollToId = function(id, evt) {
        evt.preventDefault();
        evt.stopPropagation();

        var target = id && id.indexOf('#') == 0 ? id : '#' + id;
        _.forEach($(target), function(v) {
            v.scrollIntoView({ behavior: 'smooth' });
            return false;
        });
    };
    this.scrollToId = scrollToId;
}])
;
